/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ReferralProgram = {
  __typename: "ReferralProgram",
  enrolled_at?: string | null,
  referral_count?: number | null,
  rewards_earned?: string | null,
  branch_link?: string | null,
  referrer_name?: string | null,
  referee_amount?: string | null,
  referee_completed_at?: string | null,
};

export type BankDetail = {
  __typename: "BankDetail",
  id?: string | null,
  name?: string | null,
  account_type?: string | null,
  account_number?: string | null,
  created_at?: string | null,
  default?: boolean | null,
  status?: BankDetailStatus | null,
  ins_name?: string | null,
  plaid_ins_id?: string | null,
  plaid_reauth_required?: boolean | null,
};

export enum BankDetailStatus {
  PENDING_MANUAL_VERIFICATION = "PENDING_MANUAL_VERIFICATION",
  VERIFIED = "VERIFIED",
}


export type DividendRateInput = {
  offering_id: string,
  start_date: string,
  end_date: string,
  rate: string,
};

export enum FraudReviewAction {
  ALLOW_MANUAL = "ALLOW_MANUAL",
  BLOCK_MANUAL = "BLOCK_MANUAL",
}


export enum SignatureMethod {
  DOCUSIGN = "DOCUSIGN",
  HELLOSIGN = "HELLOSIGN",
  INTERNAL = "INTERNAL",
  MANUAL = "MANUAL",
}


export type InvestorAccountApplicationInput = {
  id?: string | null,
  claims_is_accredited?: boolean | null,
  email?: string | null,
  phone?: string | null,
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  country?: string | null,
  domicile?: Domicile | null,
  individual_details?: IndividualDetailsInput | null,
  partner_id?: string | null,
};

export enum Domicile {
  USC = "USC",
  USR = "USR",
  NC = "NC",
}


export type IndividualDetailsInput = {
  account_type?: string | null,
  first_name?: string | null,
  last_name?: string | null,
  ssn?: string | null,
  dob?: string | null,
};

export type InvestorAccountApplication = {
  __typename: "InvestorAccountApplication",
  id: string,
  user_id: string,
  status: string,
  claims_is_accredited?: boolean | null,
  email?: string | null,
  email2?: string | null,
  phone?: string | null,
  phone2?: string | null,
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  country?: string | null,
  domicile?: Domicile | null,
  individual_details?: IndividualDetails | null,
  partner_id?: string | null,
};

export type IndividualDetails = {
  __typename: "IndividualDetails",
  account_type: string,
  first_name: string,
  last_name: string,
  dob?: string | null,
  middle_name?: string | null,
  owners_accredited?: boolean | null,
  total_assets?: number | null,
};

export enum AgreementCode {
  TOU_PRIVACY = "TOU_PRIVACY",
  DWOLLA_TOU_PRIVACY = "DWOLLA_TOU_PRIVACY",
  ADVISORY = "ADVISORY",
}


export type InvestorAccountFixtureConfig = {
  flags?: InvestorAccountFlagsFixture | null,
  bank_accounts?: Array< BankDetailFixture > | null,
  trades?: Array< TradeFixture > | null,
  rewards?: Array< RewardFixture > | null,
};

export type InvestorAccountFlagsFixture = {
  kyc_aml?: KycAmlFixture | null,
  referral_program?: boolean | null,
};

export type KycAmlFixture = {
  passed_aml?: boolean | null,
  passed_kyc?: boolean | null,
};

export type BankDetailFixture = {
  id?: string | null,
  name?: string | null,
  account_type?: string | null,
  account_number?: string | null,
  default?: boolean | null,
  status?: BankDetailStatus | null,
};

export type TradeFixture = {
  id?: string | null,
  principal?: string | null,
  created_at?: string | null,
  opened_at?: string | null,
  is_drip?: boolean | null,
  redemption?: RedemptionDetailsFixture | null,
  scheduled_closing_at?: string | null,
  settled_at?: string | null,
  status: TradeStatus,
  shares?: string | null,
  share_price?: string | null,
  type: TradeType,
};

export type RedemptionDetailsFixture = {
  breakout?: Array< RedemptionBreakoutFixture > | null,
  gross_amount?: string | null,
  redeem_all?: boolean | null,
  requested_amount?: string | null,
  requested_date?: string | null,
  total_cost?: string | null,
  total_dividends_discount?: string | null,
  total_shares?: string | null,
  revoke?: boolean | null,
  revoke_trade_id?: string | null,
};

export type RedemptionBreakoutFixture = {
  trade_id: string,
  shares: string,
  cost: string,
  dividends_discount?: string | null,
};

export enum TradeStatus {
  CREATED = "CREATED",
  OPENED = "OPENED",
  PENDING_CANCEL = "PENDING_CANCEL",
  PENDING_FUNDING = "PENDING_FUNDING",
  FUNDED = "FUNDED",
  SCHEDULED = "SCHEDULED",
  SETTLED = "SETTLED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
}


export enum TradeType {
  PURCHASE = "PURCHASE",
  REDEMPTION = "REDEMPTION",
}


export type RewardFixture = {
  id?: string | null,
  amount: string,
  code: RewardCode,
  posted_at?: string | null,
};

export enum RewardCode {
  AMF_RESCIND = "AMF_RESCIND",
  AMF_REWARD = "AMF_REWARD",
  DEBIT = "DEBIT",
  GIFT_REWARD = "GIFT_REWARD",
  INSTANT_EARN = "INSTANT_EARN",
  INSTANT_EARNING = "INSTANT_EARNING",
  PROMO_DIVIDEND_REWARD = "PROMO_DIVIDEND_REWARD",
  REFEREE = "REFEREE",
  REFERRAL = "REFERRAL",
}


export type InvestorAccountFixtureResult = {
  __typename: "InvestorAccountFixtureResult",
  new_user_id?: string | null,
  new_investor_account_id?: string | null,
  old_investor_account_id?: string | null,
  email_moved?: string | null,
};

export type UpdateInvestorAccountInput = {
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  country?: string | null,
  email?: string | null,
  phone?: string | null,
  employment?: EmploymentDetailsInput | null,
  individual_details?: IndividualDetailsInput | null,
};

export type EmploymentDetailsInput = {
  employment_status: EmploymentStatus,
  occupation?: string | null,
  employer?: string | null,
  employer_address?: string | null,
  employer_address2?: string | null,
  employer_city?: string | null,
  employer_state?: string | null,
  employer_zip?: string | null,
};

export enum EmploymentStatus {
  EMPLOYED = "EMPLOYED",
  RETIRED = "RETIRED",
  STUDENT = "STUDENT",
  UNEMPLOYED = "UNEMPLOYED",
}


export enum InvestorAccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  FRAUD = "FRAUD",
  PENDING = "PENDING",
}


export enum PricingPlan {
  PARTNER_WAIVED = "PARTNER_WAIVED",
  FIVE_DOLLARS_UNDER_5K = "FIVE_DOLLARS_UNDER_5K",
  FAKE_FIVE_DOLLARS_UNDER_5K = "FAKE_FIVE_DOLLARS_UNDER_5K",
  FIFTY_DOLLARS_PER_YEAR_UNDER_5K = "FIFTY_DOLLARS_PER_YEAR_UNDER_5K",
  FAKE_FIFTY_DOLLARS_PER_YEAR_UNDER_5K = "FAKE_FIFTY_DOLLARS_PER_YEAR_UNDER_5K",
}


export type ManualKYCAMLReviewInput = {
  photo_id_front_file: FileInput,
  photo_id_back_file: FileInput,
};

export type FileInput = {
  bucket: string,
  key: string,
  region: string,
  download_url?: string | null,
  upload_url?: string | null,
};

export type ManualKYCAMLReview = {
  __typename: "ManualKYCAMLReview",
  photo_id_front_file: File,
  photo_id_back_file: File,
  submitted_at?: string | null,
  completed_at?: string | null,
};

export type File = {
  __typename: "File",
  bucket?: string | null,
  key?: string | null,
  region?: string | null,
  download_url?: string | null,
  upload_url?: string | null,
};

export type SurveyV2Input = {
  broker_dealer_assoc?: boolean | null,
  annual_income?: number | null,
  net_worth?: number | null,
  objective?: SurveyV2ObjectiveChoice | null,
  pct_liquid_securities?: number | null,
  pct_illiquid_securities?: number | null,
  time_horizon?: number | null,
  risk_profile?: number | null,
  experience?: SurveyV2ExperienceInput | null,
};

export enum SurveyV2ObjectiveChoice {
  PRESERVATION = "PRESERVATION",
  BALANCED = "BALANCED",
  GROWTH = "GROWTH",
}


export type SurveyV2ExperienceInput = {
  experience_stocks?: number | null,
  experience_bonds?: number | null,
  experience_re?: number | null,
  experience_alts?: number | null,
};

export type SurveyV2 = {
  __typename: "SurveyV2",
  completed_at?: string | null,
  broker_dealer_assoc?: SurveyV2Boolean | null,
  annual_income?: SurveyV2Int | null,
  net_worth?: SurveyV2Int | null,
  objective?: SurveyV2Objective | null,
  pct_liquid_securities?: SurveyV2Int | null,
  pct_illiquid_securities?: SurveyV2Int | null,
  time_horizon?: SurveyV2Int | null,
  risk_profile?: SurveyV2Int | null,
  experience?: SurveyV2Experience | null,
  employment?: SurveyV2EmploymentDetails | null,
};

export type SurveyV2Boolean = {
  __typename: "SurveyV2Boolean",
  updated_at?: string | null,
  value?: boolean | null,
};

export type SurveyV2Int = {
  __typename: "SurveyV2Int",
  updated_at?: string | null,
  value?: number | null,
};

export type SurveyV2Objective = {
  __typename: "SurveyV2Objective",
  updated_at?: string | null,
  value?: SurveyV2ObjectiveChoice | null,
};

export type SurveyV2Experience = {
  __typename: "SurveyV2Experience",
  experience_stocks?: SurveyV2Int | null,
  experience_bonds?: SurveyV2Int | null,
  experience_re?: SurveyV2Int | null,
  experience_alts?: SurveyV2Int | null,
  migrated?: SurveyV2Int | null,
};

export type SurveyV2EmploymentDetails = {
  __typename: "SurveyV2EmploymentDetails",
  employment_status?: EmploymentStatus | null,
  occupation?: SurveyV2String | null,
  employer?: SurveyV2String | null,
  employer_address?: SurveyV2String | null,
  employer_address2?: SurveyV2String | null,
  employer_city?: SurveyV2String | null,
  employer_state?: SurveyV2String | null,
  employer_zip?: SurveyV2String | null,
};

export type SurveyV2String = {
  __typename: "SurveyV2String",
  updated_at?: string | null,
  value?: string | null,
};

export type ProfileInput = {
  app_prefs?: AppPrefsInput | null,
};

export type AppPrefsInput = {
  viewed_intro?: boolean | null,
};

export type DateIntervalInput = {
  start: string,
  end: string,
};

export type BDExportClosing = {
  __typename: "BDExportClosing",
  subscription_offer_id: string,
  closing_at: string,
  file?: File | null,
};

export enum GoalType {
  INCOME_STREAM = "INCOME_STREAM",
  RETIREMENT = "RETIREMENT",
  MAJOR_PURCHASE = "MAJOR_PURCHASE",
  SAFETY_NET = "SAFETY_NET",
  OTHER = "OTHER",
}


export type Goal = {
  __typename: "Goal",
  investor_account_id?: string | null,
  goal_id: string,
  goal_type: GoalType,
  name: string,
  start_date: string,
  target_date: string,
  target_value?: number | null,
  target_monthly_income?: number | null,
  color?: string | null,
  icon?: string | null,
  current_value?: string | null,
  is_advised: boolean,
  calculated_monthly_amount: number,
  is_on_track: boolean,
};

export type WaitListContactInfo = {
  __typename: "WaitListContactInfo",
  email?: string | null,
  user_id?: string | null,
  investor_account_id?: string | null,
  referral_code?: string | null,
  has_access?: boolean | null,
  position?: number | null,
};

export enum SocialPlatform {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  LINKEDIN = "LINKEDIN",
  TWITTER = "TWITTER",
}


export enum SocialActivity {
  COMMENT = "COMMENT",
  LIKE = "LIKE",
  SHARE = "SHARE",
}


export type FileKeyBucketInput = {
  key: string,
  bucket: string,
};

export enum WaitListAccessFilter {
  ALL = "ALL",
  GRANTED = "GRANTED",
  NON_GRANTED = "NON_GRANTED",
}


export type WaitListContactExportResult = {
  __typename: "WaitListContactExportResult",
  count: number,
  url?: string | null,
};

export type SubscriptionOfferInput = {
  display_name: string,
  description: string,
  expected_return?: string | null,
  funding_limit?: number | null,
  target_amount?: number | null,
  min_invest_amount?: number | null,
  suggested_invest_amounts?: Array< number > | null,
  leverage_pct?: string | null,
  sfr?: SFRSubscriptionOfferDetailsInput | null,
  documents?: Array< SubscriptionOfferDocumentInput > | null,
};

export type SFRSubscriptionOfferDetailsInput = {
  documents: SFRDataSheetInput,
  offering_breakdown: SFRDataSheetInput,
  volatility: string,
  info: SFRPropertyInfoInput,
  market_data: SFRMarketDataInput,
  status: SFRStatusInput,
};

export type SFRDataSheetInput = {
  link?: string | null,
  data?: Array< SFRDataSheetDataInput > | null,
};

export type SFRDataSheetDataInput = {
  description?: string | null,
  highlight?: boolean | null,
  title: string,
  link?: string | null,
  image?: ImageInput | null,
};

export type ImageInput = {
  file: FileKeyBucketInput,
  title?: string | null,
  description?: string | null,
  link?: string | null,
  url?: string | null,
};

export type SFRPropertyInfoInput = {
  address?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  baths?: string | null,
  beds?: string | null,
  description?: string | null,
  electricity?: string | null,
  gas_type?: SFRGasType | null,
  headline: string,
  images?: Array< ImageInput > | null,
  lat_long?: LatLongInput | null,
  lot_size?: number | null,
  name: string,
  nearby_employers?: Array< ImageInput > | null,
  nearby_schools?: Array< SFRNearbySchoolInput > | null,
  nearby_stores?: Array< ImageInput > | null,
  septic?: boolean | null,
  sewer?: boolean | null,
  sqft?: number | null,
  tags?: Array< SFRPropertyInfoTag > | null,
  water?: string | null,
  year?: number | null,
};

export enum SFRGasType {
  NATURAL = "NATURAL",
  PROPANE = "PROPANE",
}


export type LatLongInput = {
  lat: string,
  long: string,
};

export type SFRNearbySchoolInput = {
  description: string,
  name: string,
  number_of_reviews: number,
  link: string,
  review_rating: string,
  students: number,
};

export enum SFRPropertyInfoTag {
  EQUITY = "EQUITY",
  FEATURED = "FEATURED",
  NEW = "NEW",
  TRENDING = "TRENDING",
}


export type SFRMarketDataInput = {
  projected_dividend_yield: string,
  dividend_yield_historical_average?: string | null,
  dividend_yield_national_average?: string | null,
  dividend_yield_link: string,
  projected_equity_rate: string,
  equity_historical_average?: string | null,
  equity_national_average?: string | null,
  equity_link: string,
  summary: string,
};

export type SFRStatusInput = {
  status: SFRPropertyStatus,
  road_map?: Array< SFRRoadMapItemInput > | null,
  tenant_leasing: SFRDataSheetInput,
  updates?: Array< SFRUpdateInput > | null,
};

export enum SFRPropertyStatus {
  NEW = "NEW",
  SOLD_OUT = "SOLD_OUT",
}


export type SFRRoadMapItemInput = {
  step: SFRRoadMapStep,
  description?: string | null,
};

export enum SFRRoadMapStep {
  ACQUISITION = "ACQUISITION",
  DISPOSITION = "DISPOSITION",
  IMPROVEMENT = "IMPROVEMENT",
  LEASE_UP = "LEASE_UP",
  MANAGING = "MANAGING",
  SOURCING = "SOURCING",
}


export type SFRUpdateInput = {
  date: string,
  title: string,
  description?: string | null,
  image?: ImageInput | null,
};

export type SubscriptionOfferDocumentInput = {
  title: string,
  url: string,
  show_on_listing?: boolean | null,
  show_on_checkout?: boolean | null,
};

export type PartnerStyleInput = {
  primary_logo?: FileKeyBucketInput | null,
  secondary_logo?: FileKeyBucketInput | null,
  bg_color?: string | null,
  html?: string | null,
};

export type Partner = {
  __typename: "Partner",
  partner_id: string,
  name: string,
  style: PartnerStyle,
};

export type PartnerStyle = {
  __typename: "PartnerStyle",
  primary_logo?: File | null,
  secondary_logo?: File | null,
  bg_color?: string | null,
  html?: string | null,
};

export type DwollaCustomerDocInput = {
  file: FileKeyBucketInput,
  type?: DwollaVerificationDocType | null,
};

export enum DwollaVerificationDocType {
  ID_CARD = "ID_CARD",
  LICENSE = "LICENSE",
  PASSPORT = "PASSPORT",
}


export type Lead = {
  __typename: "Lead",
  id: string,
  stored_at?: string | null,
  lead_source?: string | null,
  first_name?: string | null,
  last_name?: string | null,
  email?: string | null,
  phone?: string | null,
};

export type ReferralCampaign = {
  __typename: "ReferralCampaign",
  start_date?: string | null,
  end_date?: string | null,
  referrer_amount?: string | null,
  referee_amount?: string | null,
  name?: string | null,
};

export type PaginatedReferralCampaigns = {
  __typename: "PaginatedReferralCampaigns",
  items:  Array<ReferralCampaign >,
  next_token?: string | null,
};

export type InvestorAccount = {
  __typename: "InvestorAccount",
  id: string,
  name?: string | null,
  email?: string | null,
  email_verified_at?: string | null,
  email2?: string | null,
  phone?: string | null,
  phone2?: string | null,
  address?: string | null,
  address2?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  country?: string | null,
  status?: InvestorAccountStatus | null,
  individual_details?: IndividualDetails | null,
  employment?: EmploymentDetails | null,
  domicile?: Domicile | null,
  needs_manual_kyc_aml_review?: boolean | null,
  manual_kyc_aml_review?: ManualKYCAMLReview | null,
  accreditation?: Accreditation | null,
  accreditation_self?: SelfAccreditation | null,
  accreditation_hellosign?: HelloSignAccreditation | null,
  accreditation_manual?: ManualAccreditation | null,
  accredited_survey?: SurveyMeta | null,
  non_accredited_survey?: SurveyMeta | null,
  non_accredited_survey_v2?: SurveyV2 | null,
  claims_is_accredited?: boolean | null,
  has_bd_account?: boolean | null,
  aml_date?: string | null,
  aml_status?: string | null,
  kyc_status?: string | null,
  kyc_aml?: KycAml | null,
  created_at?: string | null,
  created_ip_address?: string | null,
  pending_trades?:  Array<Trade > | null,
  was_invited?: boolean | null,
  rr_suitability_approval?: RrSuitabilityApproval | null,
  rr_suitability_notes?:  Array<RRSuitabilityNote > | null,
  referral_program?: ReferralProgram | null,
  rewards_balance?: string | null,
  tally_dividends?: string | null,
  tally_rewards_earned?: string | null,
  tally_rewards_applied?: string | null,
  is_name_locked?: boolean | null,
  promos?:  Array<Promo > | null,
  pricing_plan?: PricingPlan | null,
  accepted_tc_at?: string | null,
  unaccepted_agreements?: Array< AgreementCode > | null,
  partner?: Partner | null,
  hints?:  Array<InvestorHint > | null,
};

export type EmploymentDetails = {
  __typename: "EmploymentDetails",
  employment_status: EmploymentStatus,
  occupation?: string | null,
  employer?: string | null,
  employer_address?: string | null,
  employer_address2?: string | null,
  employer_city?: string | null,
  employer_state?: string | null,
  employer_zip?: string | null,
};

export type Accreditation = {
  __typename: "Accreditation",
  started_at: string,
  accredited_on?: string | null,
  method: SignatureMethod,
  status: AccreditationStatus,
  docusign_details?: DocuSignDetails | null,
  hellosign_details?: HelloSignDetails | null,
};

export enum AccreditationStatus {
  OPEN = "OPEN",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}


export type DocuSignDetails = {
  __typename: "DocuSignDetails",
  signer_name?: string | null,
  signer_email?: string | null,
};

export type HelloSignDetails = {
  __typename: "HelloSignDetails",
  signer_name?: string | null,
  signer_email?: string | null,
};

export type SelfAccreditation = {
  __typename: "SelfAccreditation",
  status: AccreditationStatus,
  created_at: string,
  accredited_at?: string | null,
  reason_annual_income?: boolean | null,
  reason_net_worth?: boolean | null,
  reason_certification?: boolean | null,
  reason_employment?: boolean | null,
};

export type HelloSignAccreditation = {
  __typename: "HelloSignAccreditation",
  status: AccreditationStatus,
  created_at: string,
  accredited_at?: string | null,
  signature_details: HelloSignDetails,
};

export type ManualAccreditation = {
  __typename: "ManualAccreditation",
  status: AccreditationStatus,
  created_at: string,
  accredited_at?: string | null,
};

export type SurveyMeta = {
  __typename: "SurveyMeta",
  date_submitted?: string | null,
};

export type KycAml = {
  __typename: "KycAml",
  passed_aml?: boolean | null,
  passed_kyc?: boolean | null,
};

export type Trade = {
  __typename: "Trade",
  id: string,
  subscription_offer?: SubscriptionOffer | null,
  principal?: string | null,
  created_at?: string | null,
  opened_at?: string | null,
  is_drip?: boolean | null,
  redemption?: RedemptionDetails | null,
  scheduled_closing_at?: string | null,
  settled_at?: string | null,
  status?: TradeStatus | null,
  shares?: string | null,
  share_price?: string | null,
  type?: TradeType | null,
  auto_invest?: TradeAutoInvestDetails | null,
  rr_suitability_approval?: RrSuitabilityApproval | null,
  principal_suitability_approval?: PrincipalSuitabilityApproval | null,
  goal_id?: string | null,
};

export type SubscriptionOffer = {
  __typename: "SubscriptionOffer",
  id: string,
  listed_at?: string | null,
  slug?: string | null,
  name?: string | null,
  display_name?: string | null,
  entity_name?: string | null,
  description?: string | null,
  offering_id?: string | null,
  status?: SubscriptionStatus | null,
  auto_invest_doc_v2_id?: string | null,
  auto_invest_doc_v2?: File | null,
  documents?:  Array<SubscriptionOfferDocument > | null,
  current_apy?: string | null,
  expected_return?: number | null,
  regulatory_rule_type?: RegulatoryRuleType | null,
  offer_type?: OfferType | null,
  asset_class?: AssetClass | null,
  investor_count?: SettledPendingTotal | null,
  subscription_doc?: File | null,
  raised_amount?: SettledPendingTotal | null,
  funding_limit?: number | null,
  target_amount?: number | null,
  require_whole_shares?: boolean | null,
  min_invest_amount?: number | null,
  max_invest_amount?: number | null,
  share_price?: string | null,
  suggested_invest_amounts?: Array< number > | null,
  leverage_pct?: string | null,
  non_accredited_slots_full?: boolean | null,
  sfr?: SFRSubscriptionOfferDetails | null,
  total_shares?: string | null,
  auto_invest_doc_id?: string | null,
  auto_invest_doc?: File | null,
  hints?: Array< SubscriptionOfferHint > | null,
};

export type BaseSubscriptionOffer = {
  __typename: "BaseSubscriptionOffer",
  id: string,
  display_name?: string | null,
  entity_name?: string | null,
  offering_id?: string | null,
  status?: SubscriptionStatus | null,
};

export type BDSubscriptionOffer = {
  __typename: "BDSubscriptionOffer",
  id: string,
  display_name?: string | null,
  entity_name?: string | null,
  offering_id?: string | null,
  status?: SubscriptionStatus | null,
  closings_to_export?: number | null,
  last_closing_date?: string | null,
  total_closings?: number | null,
  total_dollars?: string | null,
};

export enum SubscriptionStatus {
  DRAFT = "DRAFT",
  LISTED = "LISTED",
  CLOSED = "CLOSED",
}


export type SubscriptionOfferDocument = {
  __typename: "SubscriptionOfferDocument",
  title: string,
  url: string,
  show_on_listing?: boolean | null,
  show_on_checkout?: boolean | null,
};

export enum RegulatoryRuleType {
  REG_D_506B = "REG_D_506B",
  REG_D_506C = "REG_D_506C",
  REG_A_PLUS_TIER1 = "REG_A_PLUS_TIER1",
  REG_A_PLUS_TIER2 = "REG_A_PLUS_TIER2",
}


export enum OfferType {
  COMMON_EQUITY = "COMMON_EQUITY",
  DEBT = "DEBT",
  FUND = "FUND",
  PREFERRED_EQUITY = "PREFERRED_EQUITY",
}


export enum AssetClass {
  MIXED = "MIXED",
  SFR = "SFR",
}


export type SettledPendingTotal = {
  __typename: "SettledPendingTotal",
  settled?: number | null,
  pending?: number | null,
  total?: number | null,
};

export type SFRSubscriptionOfferDetails = {
  __typename: "SFRSubscriptionOfferDetails",
  documents: SFRDataSheet,
  offering_breakdown: SFRDataSheet,
  volatility: string,
  info: SFRPropertyInfo,
  market_data: SFRMarketData,
  status: SFRStatus,
};

export type SFRDataSheet = {
  __typename: "SFRDataSheet",
  link?: string | null,
  data?:  Array<SFRDataSheetData > | null,
};

export type SFRDataSheetData = {
  __typename: "SFRDataSheetData",
  description?: string | null,
  highlight?: boolean | null,
  title: string,
  link?: string | null,
  image?: Image | null,
};

export type Image = {
  __typename: "Image",
  url: string,
  title?: string | null,
  description?: string | null,
  link?: string | null,
  file?: File | null,
};

export type SFRPropertyInfo = {
  __typename: "SFRPropertyInfo",
  address?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  baths?: string | null,
  beds?: string | null,
  description?: string | null,
  electricity?: string | null,
  gas_type?: SFRGasType | null,
  headline: string,
  images?:  Array<Image > | null,
  lat_long?: LatLong | null,
  lot_size?: number | null,
  name: string,
  nearby_employers?:  Array<Image > | null,
  nearby_schools?:  Array<SFRNearbySchool > | null,
  nearby_stores?:  Array<Image > | null,
  septic?: boolean | null,
  sewer?: boolean | null,
  sqft?: number | null,
  tags?: Array< SFRPropertyInfoTag > | null,
  water?: string | null,
  year?: number | null,
};

export type LatLong = {
  __typename: "LatLong",
  lat: string,
  long: string,
};

export type SFRNearbySchool = {
  __typename: "SFRNearbySchool",
  description: string,
  name: string,
  number_of_reviews: number,
  link: string,
  review_rating: string,
  students: number,
};

export type SFRMarketData = {
  __typename: "SFRMarketData",
  projected_dividend_yield: string,
  dividend_yield_historical_average?: string | null,
  dividend_yield_national_average?: string | null,
  dividend_yield_link: string,
  projected_equity_rate: string,
  equity_historical_average?: string | null,
  equity_national_average?: string | null,
  equity_link: string,
  summary: string,
};

export type SFRStatus = {
  __typename: "SFRStatus",
  status: SFRPropertyStatus,
  road_map?:  Array<SFRRoadMapItem > | null,
  tenant_leasing: SFRDataSheet,
  updates?:  Array<SFRUpdate > | null,
};

export type SFRRoadMapItem = {
  __typename: "SFRRoadMapItem",
  step: SFRRoadMapStep,
  description?: string | null,
};

export type SFRUpdate = {
  __typename: "SFRUpdate",
  date: string,
  title: string,
  description?: string | null,
  image?: Image | null,
};

export enum SubscriptionOfferHint {
  CAPITAL_FULL = "CAPITAL_FULL",
  CHECK_WAITLIST = "CHECK_WAITLIST",
  NON_ACCREDITED_SLOTS_FULL = "NON_ACCREDITED_SLOTS_FULL",
}


export type RedemptionDetails = {
  __typename: "RedemptionDetails",
  requested_amount?: string | null,
  redeem_all?: boolean | null,
  requested_date?: string | null,
};

export type TradeAutoInvestDetails = {
  __typename: "TradeAutoInvestDetails",
  day?: string | null,
};

export type RrSuitabilityApproval = {
  __typename: "RrSuitabilityApproval",
  approved_by?: string | null,
  approved_at?: string | null,
  updated_at?: string | null,
  approval_status?: ApprovalStatus | null,
  snooze_until?: string | null,
};

export enum ApprovalStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  UNDER_REVIEW = "UNDER_REVIEW",
  NOT_APPROVED = "NOT_APPROVED",
}


export type PrincipalSuitabilityApproval = {
  __typename: "PrincipalSuitabilityApproval",
  approved_by?: string | null,
  updated_at?: string | null,
  approval_status?: ApprovalStatus | null,
  snooze_until?: string | null,
};

export type RRSuitabilityNote = {
  __typename: "RRSuitabilityNote",
  created_at?: string | null,
  author?: string | null,
  note?: string | null,
};

export type Promo = {
  __typename: "Promo",
  code: PromoCode,
  name: string,
  start_date: string,
  end_date: string,
};

export enum PromoCode {
  ONE_YEAR_FEE_FREE = "ONE_YEAR_FEE_FREE",
}


export type InvestorHint = {
  __typename: "InvestorHint",
  code: InvestorHintCode,
  status: HintStatus,
  severity: HintSeverity,
  text: string,
};

export enum InvestorHintCode {
  ACCRED_SELF_SURVEY_INCONSISTENT = "ACCRED_SELF_SURVEY_INCONSISTENT",
  DWOLLA_CUSTOMER_DOCUMENT = "DWOLLA_CUSTOMER_DOCUMENT",
  DWOLLA_CUSTOMER_SUSPENDED = "DWOLLA_CUSTOMER_SUSPENDED",
}


export enum HintStatus {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
}


export enum HintSeverity {
  CRITICAL = "CRITICAL",
}


export type ConsolidatedInvestor = {
  __typename: "ConsolidatedInvestor",
  account_value?: AccountValue | null,
  acc_value?: PositionValue | null,
  balance_history?:  Array<BalanceChange > | null,
  bank_accounts?:  Array<BankDetail > | null,
  dividends: DividendsV3,
  investor?: InvestorAccount | null,
  referral_campaign: ReferralCampaign,
  referrals?:  Array<Referral > | null,
  trades?:  Array<Trade > | null,
  transactions?:  Array<TransactionV2 > | null,
  user_profile?: MyProfile | null,
  auto_invests?:  Array<AutoInvestScheduleV2 > | null,
  goals?:  Array<Goal > | null,
  subscription_offer?: SubscriptionOffer | null,
  subscription?: Subscription | null,
  subscriptions?:  Array<Subscription > | null,
};

export type AccountValue = {
  __typename: "AccountValue",
  pending_value: string,
  settled_value: string,
  total_value: string,
};

export type PositionValue = {
  __typename: "PositionValue",
  pending_value: string,
  settled_value: string,
  total_value: string,
};

export type BalanceChange = {
  __typename: "BalanceChange",
  changed_on: string,
  balance: string,
};

export type DividendsV3 = {
  __typename: "DividendsV3",
  recent_dividends:  Array<Dividend >,
  months:  Array<Dividend >,
};

export type Dividend = {
  __typename: "Dividend",
  amount: string,
  issued_at: string,
  period: string,
  rewards_applied?: string | null,
};

export type Referral = {
  __typename: "Referral",
  name?: string | null,
  created_at?: string | null,
  completed_at?: string | null,
  amount?: string | null,
};

export type TransactionV2 = {
  __typename: "TransactionV2",
  id: string,
  subscription_offer_id?: string | null,
  subscription_offer?: SubscriptionOffer | null,
  posted_at?: string | null,
  amount?: string | null,
  waived_amount?: string | null,
  code?: TransactionCode | null,
  title?: string | null,
  description?: string | null,
  dividend_detail?: TxnDividendDetails | null,
};

export enum TransactionCode {
  FEE_BANK = "FEE_BANK",
  DEPOSIT_CANCEL = "DEPOSIT_CANCEL",
  DIVIDEND = "DIVIDEND",
  DIVIDEND_REINVESTMENT = "DIVIDEND_REINVESTMENT",
  DEPOSIT_ESCROW = "DEPOSIT_ESCROW",
  PLAN_FEE = "PLAN_FEE",
  TRADE_BUY = "TRADE_BUY",
  TRADE_AUTO_BUY = "TRADE_AUTO_BUY",
  TRADE_SELL = "TRADE_SELL",
  REVOKE = "REVOKE",
  WITHDRAWAL = "WITHDRAWAL",
}


export type TxnDividendDetails = {
  __typename: "TxnDividendDetails",
  rewards_applied?: string | null,
  base_yield?: string | null,
  total_yield?: string | null,
};

export type MyProfile = {
  __typename: "MyProfile",
  user_id: string,
  first_name?: string | null,
  last_name?: string | null,
  username?: string | null,
  headshot_url?: string | null,
  headshot?: File | null,
  friend?: FriendDetail | null,
  signature_file?: File | null,
  branch_link?: string | null,
  has_initial_branch_data?: boolean | null,
  app_prefs?: AppPrefs | null,
};

export type FriendDetail = {
  __typename: "FriendDetail",
  status: FriendStatus,
  is_requester?: boolean | null,
  created_at?: string | null,
  accepted_at?: string | null,
};

export enum FriendStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  IGNORED = "IGNORED",
}


export type AppPrefs = {
  __typename: "AppPrefs",
  viewed_intro?: boolean | null,
};

export type AutoInvestScheduleV2 = {
  __typename: "AutoInvestScheduleV2",
  investor_account_id: string,
  autoinvest_id: string,
  subscription_offer_id: string,
  created_at?: string | null,
  start_date: string,
  amount: number,
  frequency: string,
  interval: number,
  days_of_month?: Array< number > | null,
  days_of_week?: Array< number > | null,
  is_disabled?: boolean | null,
  goal_id?: string | null,
};

export type Subscription = {
  __typename: "Subscription",
  auto_invest_signature?: AutoInvestSignature | null,
  subscription_offer_id?: string | null,
  subscription_offer?: SubscriptionOffer | null,
  signature?: SubscriptionSignature | null,
  total_shares?: string | null,
  cost_basis?: string | null,
  tally_primary_cost?: string | null,
  tally_dividends?: string | null,
  tally_drip_cost?: string | null,
  share_price?: string | null,
  value?: PositionValue | null,
};

export type AutoInvestSignature = {
  __typename: "AutoInvestSignature",
  method: SignatureMethod,
  signed_at?: string | null,
  internalsign_details?: InternalSignDetails | null,
};

export type InternalSignDetails = {
  __typename: "InternalSignDetails",
  id: string,
  user_id: string,
  investor_account_id?: string | null,
  signed_at?: string | null,
  user_full_name?: string | null,
  file?: File | null,
};

export type SubscriptionSignature = {
  __typename: "SubscriptionSignature",
  method: SignatureMethod,
  sent_at?: string | null,
  signed_at?: string | null,
};

export type PaginatedInvestorAccountApplications = {
  __typename: "PaginatedInvestorAccountApplications",
  items:  Array<InvestorAccountApplication >,
  next_token?: string | null,
};

export type Survey = {
  __typename: "Survey",
  questions?:  Array<SurveyItem > | null,
};

export type SurveyItem = {
  __typename: "SurveyItem",
  question: string,
  description?: string | null,
  answer?: SurveyAnswer | null,
};

export type SurveyAnswer = {
  __typename: "SurveyAnswer",
  type: string,
  boolean?: boolean | null,
  choice?: SurveyChoice | null,
  choices?: SurveyMultiChoice | null,
  number?: number | null,
  text?: string | null,
};

export type SurveyChoice = {
  __typename: "SurveyChoice",
  label?: string | null,
};

export type SurveyMultiChoice = {
  __typename: "SurveyMultiChoice",
  labels?: Array< string > | null,
  other?: string | null,
};

export type PaginatedOfferings = {
  __typename: "PaginatedOfferings",
  items:  Array<Offering >,
  next_token?: string | null,
};

export type Offering = {
  __typename: "Offering",
  id: string,
  property_type: PropertyType,
  share_price?: string | null,
  target_hold_months?: number | null,
  title: string,
};

export enum PropertyType {
  OFFICE = "OFFICE",
  MIXED = "MIXED",
  MULTI_FAMILY = "MULTI_FAMILY",
  RETAIL = "RETAIL",
  SENIOR = "SENIOR",
  SINGLE_FAMILY = "SINGLE_FAMILY",
  STUDENT = "STUDENT",
}


export type PaginatedDividendRates = {
  __typename: "PaginatedDividendRates",
  items:  Array<DividendRate >,
  next_token?: string | null,
};

export type DividendRate = {
  __typename: "DividendRate",
  start_date?: string | null,
  end_date?: string | null,
  rate?: string | null,
};

export type PaginatedReferrals = {
  __typename: "PaginatedReferrals",
  items:  Array<Referral >,
  next_token?: string | null,
};

export type PaginatedRewards = {
  __typename: "PaginatedRewards",
  items:  Array<Reward >,
  next_token?: string | null,
};

export type Reward = {
  __typename: "Reward",
  id: string,
  posted_at?: string | null,
  amount?: string | null,
  description?: string | null,
  code?: RewardCode | null,
};

export type PaginatedSubscriptionOffers = {
  __typename: "PaginatedSubscriptionOffers",
  items:  Array<SubscriptionOffer >,
  next_token?: string | null,
};

export type PaginatedTrades = {
  __typename: "PaginatedTrades",
  items:  Array<Trade >,
  next_token?: string | null,
};

export type BalanceHistory = {
  __typename: "BalanceHistory",
  items?:  Array<BalanceChange > | null,
};

export type PaginatedTransactionsV2 = {
  __typename: "PaginatedTransactionsV2",
  items:  Array<TransactionV2 >,
  next_token?: string | null,
};

export type PaginatedAutoInvestSchedulesV2 = {
  __typename: "PaginatedAutoInvestSchedulesV2",
  items:  Array<AutoInvestScheduleV2 >,
  next_token?: string | null,
};

export type PaginatedUserInvestorRoles = {
  __typename: "PaginatedUserInvestorRoles",
  items:  Array<UserInvestorRole >,
  next_token?: string | null,
};

export type UserInvestorRole = {
  __typename: "UserInvestorRole",
  investor_id: string,
  user_id: string,
  role: string,
};

export type OtherProfile = {
  __typename: "OtherProfile",
  id: string,
  first_name?: string | null,
  last_name?: string | null,
  username?: string | null,
  headshot_url?: string | null,
  headshot?: ReadOnlyFile | null,
  friend?: FriendDetail | null,
};

export type ReadOnlyFile = {
  __typename: "ReadOnlyFile",
  download_url?: string | null,
};

export enum TradesApprovalFilter {
  ALL = "ALL",
  READY = "READY",
  SNOOZED = "SNOOZED",
}


export type TradePendingApproval = {
  __typename: "TradePendingApproval",
  trade?: Trade | null,
  investor_account?: InvestorAccount | null,
  extra_info?: TradePendingApprovalExtraInfo | null,
  subscription?: Subscription | null,
};

export type TradePendingApprovalExtraInfo = {
  __typename: "TradePendingApprovalExtraInfo",
  is_accredited: boolean,
  original_kyc_aml_info?: string | null,
  signed_doc_url?: string | null,
};

export type PendingManualKYCAMLReview = {
  __typename: "PendingManualKYCAMLReview",
  investor_account?: InvestorAccount | null,
  photo_id_front_uri?: string | null,
  photo_id_back_uri?: string | null,
};

export type YearInReview = {
  __typename: "YearInReview",
  account_join_date: string,
  yearly_details?:  Array<YearInReviewDetail > | null,
};

export type YearInReviewDetail = {
  __typename: "YearInReviewDetail",
  year: number,
  bonus_payout_percent?: string | null,
  bonus_payout_percentile?: string | null,
  ending_balance?: string | null,
  ending_balance_percentile?: string | null,
  investment_count?: number | null,
  investment_count_percentile?: string | null,
  investment_sum?: string | null,
  investment_sum_percentile?: string | null,
};

export type TaxDocumentGroup = {
  __typename: "TaxDocumentGroup",
  tax_period: number,
  forms?:  Array<TaxDocumentDetail > | null,
};

export type TaxDocumentDetail = {
  __typename: "TaxDocumentDetail",
  form_code: string,
  suffix?: string | null,
  document_file: File,
};

export type RedemptionPreflightInfo = {
  __typename: "RedemptionPreflightInfo",
  full_value: string,
  redeemable_value: string,
  time_restricted_value?: string | null,
  goal_restricted_value?: string | null,
  next_scheduled_date: string,
  pending_investments: string,
  pending_redemptions: string,
};

export type InvestPreflightInfo = {
  __typename: "InvestPreflightInfo",
  hints?: Array< InvestPreflightHint > | null,
};

export enum InvestPreflightHint {
  BANK_ACCOUNT_ITEM_LOGIN_REQUIRED = "BANK_ACCOUNT_ITEM_LOGIN_REQUIRED",
  LEGACY_BANK_ACCOUNT = "LEGACY_BANK_ACCOUNT",
  NO_DEFAULT_BANK_ACCOUNT = "NO_DEFAULT_BANK_ACCOUNT",
  ACCEPT_DWOLLA_TC = "ACCEPT_DWOLLA_TC",
}


export type GoalHistoryItem = {
  __typename: "GoalHistoryItem",
  date: string,
  value: string,
};

export type WaitListShortContactInfo = {
  __typename: "WaitListShortContactInfo",
  email?: string | null,
  referral_code?: string | null,
  has_access?: boolean | null,
  position?: number | null,
};

export type PaginatedWaitListContacts = {
  __typename: "PaginatedWaitListContacts",
  items:  Array<WaitListContactInfo >,
  next_token?: string | null,
};

export type MonthlyStatement = {
  __typename: "MonthlyStatement",
  holdings: MSHoldings,
  activity: MSActivity,
};

export type MSHoldings = {
  __typename: "MSHoldings",
  items?:  Array<MSHolding > | null,
  totals: MSHoldingTotals,
};

export type MSHolding = {
  __typename: "MSHolding",
  subscription_offer_name: string,
  type: string,
  start_shares: string,
  end_shares: string,
  end_share_price: string,
  end_value: string,
};

export type MSHoldingTotals = {
  __typename: "MSHoldingTotals",
  start_value: string,
  end_value: string,
};

export type MSActivity = {
  __typename: "MSActivity",
  trades: MSTrades,
  earnings: MSEarnings,
  rewards: MSRewards,
  fees: MSFees,
};

export type MSTrades = {
  __typename: "MSTrades",
  items?:  Array<MSTrade > | null,
  totals: MSTradeTotals,
};

export type MSTrade = {
  __typename: "MSTrade",
  date: string,
  subscription_offer_name: string,
  description: string,
  share_price?: string | null,
  shares?: string | null,
  amount?: string | null,
};

export type MSTradeTotals = {
  __typename: "MSTradeTotals",
  amount: string,
};

export type MSEarnings = {
  __typename: "MSEarnings",
  items?:  Array<MSEarning > | null,
  totals: MSEarningTotals,
};

export type MSEarning = {
  __typename: "MSEarning",
  date: string,
  subscription_offer_name: string,
  type: string,
  rewards_applied?: string | null,
  net_amount: string,
};

export type MSEarningTotals = {
  __typename: "MSEarningTotals",
  rewards_applied: string,
  net_amount: string,
};

export type MSRewards = {
  __typename: "MSRewards",
  items?:  Array<MSReward > | null,
  totals: MSRewardTotals,
};

export type MSReward = {
  __typename: "MSReward",
  date: string,
  description: string,
  amount?: string | null,
  end_balance: string,
};

export type MSRewardTotals = {
  __typename: "MSRewardTotals",
  start_balance: string,
  end_balance: string,
};

export type MSFees = {
  __typename: "MSFees",
  items?:  Array<MSFee > | null,
  totals: MSFeeTotals,
};

export type MSFee = {
  __typename: "MSFee",
  date: string,
  description: string,
  fee_amount?: string | null,
};

export type MSFeeTotals = {
  __typename: "MSFeeTotals",
  fee_amount: string,
};

export type BDSubscriptionOfferClosing = {
  __typename: "BDSubscriptionOfferClosing",
  subscription_offer_id: string,
  closing_at: string,
  display_name?: string | null,
  entity_name?: string | null,
  offering_id?: string | null,
  total_dollars?: string | null,
  drip_amount?: string | null,
  num_trades?: number | null,
  bd_exported_at?: string | null,
  skip_bd_export?: boolean | null,
};

export type AddReferrerMutationVariables = {
  referrer_id: string,
  referrer_tags: Array< string | null >,
};

export type AddReferrerMutation = {
  addReferrer?: boolean | null,
};

export type JoinReferralProgramMutationVariables = {
  investor_account_id: string,
};

export type JoinReferralProgramMutation = {
  joinReferralProgram:  {
    __typename: "ReferralProgram",
    enrolled_at?: string | null,
    referral_count?: number | null,
    rewards_earned?: string | null,
    branch_link?: string | null,
    referrer_name?: string | null,
    referee_amount?: string | null,
    referee_completed_at?: string | null,
  },
};

export type AccreditViaHelloSignMutationVariables = {
  investor_account_id: string,
  name: string,
  email: string,
};

export type AccreditViaHelloSignMutation = {
  accreditViaHelloSign?: boolean | null,
};

export type AccreditSelfMutationVariables = {
  investor_account_id: string,
  is_accredited: boolean,
  reason_annual_income?: boolean | null,
  reason_net_worth?: boolean | null,
  reason_certification?: boolean | null,
  reason_employment?: boolean | null,
};

export type AccreditSelfMutation = {
  accreditSelf?: boolean | null,
};

export type AddBankAccountMutationVariables = {
  investor_account_id: string,
  public_token: string,
  bank_account_name: string,
  bank_account_id: string,
  bank_account_type: string,
};

export type AddBankAccountMutation = {
  addBankAccount?:  {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null,
};

export type CreatePlaidLinkTokenMutationVariables = {
  investor_account_id: string,
  bank_account_id?: string | null,
  android_package_name?: string | null,
};

export type CreatePlaidLinkTokenMutation = {
  createPlaidLinkToken?: string | null,
};

export type AddBankAccountViaPlaidMutationVariables = {
  investor_account_id: string,
  public_token: string,
  bank_account_id: string,
  bank_account_name?: string | null,
  bank_account_type?: string | null,
};

export type AddBankAccountViaPlaidMutation = {
  addBankAccountViaPlaid?:  {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null,
};

export type FinishPlaidBankAccountVerifyMutationVariables = {
  investor_account_id: string,
  bank_account_id: string,
};

export type FinishPlaidBankAccountVerifyMutation = {
  finishPlaidBankAccountVerify?:  {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null,
};

export type RemoveBankAccountMutationVariables = {
  investor_account_id: string,
  bank_account_id: string,
};

export type RemoveBankAccountMutation = {
  removeBankAccount?:  {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null,
};

export type SetDefaultBankAccountMutationVariables = {
  investor_account_id: string,
  bank_account_id: string,
};

export type SetDefaultBankAccountMutation = {
  setDefaultBankAccount?:  {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null,
};

export type DeleteUnconfirmedUserMutationVariables = {
  email: string,
};

export type DeleteUnconfirmedUserMutation = {
  deleteUnconfirmedUser?: boolean | null,
};

export type DeleteAutoInvestScheduleV2MutationVariables = {
  investor_account_id: string,
  autoinvest_id: string,
};

export type DeleteAutoInvestScheduleV2Mutation = {
  deleteAutoInvestScheduleV2?: boolean | null,
};

export type CreateAutoInvestScheduleV2MutationVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
  amount: number,
  start_date?: string | null,
  frequency: string,
  interval: number,
  days_of_month?: Array< number > | null,
  days_of_week?: Array< number > | null,
  goal_id?: string | null,
};

export type CreateAutoInvestScheduleV2Mutation = {
  createAutoInvestScheduleV2?: boolean | null,
};

export type ModifyAutoInvestScheduleMutationVariables = {
  investor_account_id: string,
  autoinvest_id: string,
  amount: number,
  start_date?: string | null,
  frequency: string,
  interval: number,
  days_of_month?: Array< number > | null,
  days_of_week?: Array< number > | null,
};

export type ModifyAutoInvestScheduleMutation = {
  modifyAutoInvestSchedule: string,
};

export type CreateReferralMutationVariables = {
  referrer_id: string,
  referee_id: string,
};

export type CreateReferralMutation = {
  createReferral?: boolean | null,
};

export type CreateReferralCampaignMutationVariables = {
  referrer_amount: string,
  referee_amount: string,
  start_date: string,
  end_date: string,
  name: string,
};

export type CreateReferralCampaignMutation = {
  createReferralCampaign?: boolean | null,
};

export type UpdateReferralCampaignMutationVariables = {
  start_date: string,
  end_date: string,
};

export type UpdateReferralCampaignMutation = {
  updateReferralCampaign?: boolean | null,
};

export type CloseAccountMutationVariables = {
  investor_account_id: string,
  is_fraud?: boolean | null,
};

export type CloseAccountMutation = {
  closeAccount?: boolean | null,
};

export type CancelTradeMutationVariables = {
  trade_id: string,
  reason: string,
  silently?: boolean | null,
};

export type CancelTradeMutation = {
  cancelTrade?: boolean | null,
};

export type CancelPurchaseTradeMutationVariables = {
  trade_id: string,
  reason: string,
  silently?: boolean | null,
};

export type CancelPurchaseTradeMutation = {
  cancelPurchaseTrade?: boolean | null,
};

export type CancelRedemptionTradeMutationVariables = {
  trade_id: string,
};

export type CancelRedemptionTradeMutation = {
  cancelRedemptionTrade?: boolean | null,
};

export type UnscheduleTradeMutationVariables = {
  trade_id: string,
};

export type UnscheduleTradeMutation = {
  unscheduleTrade?: boolean | null,
};

export type DeclareDividendMutationVariables = {
  dividend_rate?: DividendRateInput | null,
};

export type DeclareDividendMutation = {
  declareDividend?: boolean | null,
};

export type FraudReviewTradeMutationVariables = {
  trade_id: string,
  action: FraudReviewAction,
};

export type FraudReviewTradeMutation = {
  fraudReviewTrade?: boolean | null,
};

export type InvestMutationVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
  amount: number,
  signature_method?: SignatureMethod | null,
  goal_id?: string | null,
};

export type InvestMutation = {
  invest: string,
};

export type RedeemMutationVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
  amount?: number | null,
  redeem_all?: boolean | null,
  requested_date?: string | null,
  revoke?: boolean | null,
  revoke_trade_id?: string | null,
};

export type RedeemMutation = {
  redeem: string,
};

export type CreateOrUpdateInvestorAccountApplicationMutationVariables = {
  investor_account: InvestorAccountApplicationInput,
};

export type CreateOrUpdateInvestorAccountApplicationMutation = {
  createOrUpdateInvestorAccountApplication:  {
    __typename: "InvestorAccountApplication",
    id: string,
    user_id: string,
    status: string,
    claims_is_accredited?: boolean | null,
    email?: string | null,
    email2?: string | null,
    phone?: string | null,
    phone2?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    country?: string | null,
    domicile?: Domicile | null,
    individual_details?:  {
      __typename: "IndividualDetails",
      account_type: string,
      first_name: string,
      last_name: string,
      dob?: string | null,
      middle_name?: string | null,
      owners_accredited?: boolean | null,
      total_assets?: number | null,
    } | null,
    partner_id?: string | null,
  },
};

export type ApproveInvestorAccountApplicationMutationVariables = {
  application_id: string,
  pricing_plan?: string | null,
  accepted_tc?: boolean | null,
};

export type ApproveInvestorAccountApplicationMutation = {
  approveInvestorAccountApplication?: boolean | null,
};

export type ApproveInvestorAccountApplicationV2MutationVariables = {
  application_id: string,
  pricing_plan?: string | null,
  agreements: Array< AgreementCode >,
};

export type ApproveInvestorAccountApplicationV2Mutation = {
  approveInvestorAccountApplicationV2?: boolean | null,
};

export type AcceptTermsAndConditionsMutationVariables = {
  investor_account_id: string,
};

export type AcceptTermsAndConditionsMutation = {
  acceptTermsAndConditions?: boolean | null,
};

export type AcceptTermsAndConditionsV2MutationVariables = {
  investor_account_id: string,
  agreements: Array< AgreementCode >,
};

export type AcceptTermsAndConditionsV2Mutation = {
  acceptTermsAndConditionsV2?: boolean | null,
};

export type ConfigureInvestorAccountFixtureMutationVariables = {
  user_id: string,
  password: string,
  fixture_config: InvestorAccountFixtureConfig,
};

export type ConfigureInvestorAccountFixtureMutation = {
  configureInvestorAccountFixture?:  {
    __typename: "InvestorAccountFixtureResult",
    new_user_id?: string | null,
    new_investor_account_id?: string | null,
    old_investor_account_id?: string | null,
    email_moved?: string | null,
  } | null,
};

export type UpdateInvestorAccountMutationVariables = {
  investor_account_id: string,
  investor_account: UpdateInvestorAccountInput,
};

export type UpdateInvestorAccountMutation = {
  updateInvestorAccount?: boolean | null,
};

export type ConfirmPhoneNumberUpdateMutationVariables = {
  investor_account_id: string,
  phone_number: string,
};

export type ConfirmPhoneNumberUpdateMutation = {
  confirmPhoneNumberUpdate?: boolean | null,
};

export type ReopenInvestorAccountMutationVariables = {
  investor_account_id: string,
};

export type ReopenInvestorAccountMutation = {
  reopenInvestorAccount?: InvestorAccountStatus | null,
};

export type SetPricingPlanMutationVariables = {
  investor_account_id: string,
  pricing_plan: PricingPlan,
};

export type SetPricingPlanMutation = {
  setPricingPlan?: boolean | null,
};

export type SubmitKYCAMLManualReviewMutationVariables = {
  investor_account_id: string,
  manual_kyc_aml_review: ManualKYCAMLReviewInput,
};

export type SubmitKYCAMLManualReviewMutation = {
  submitKYCAMLManualReview?:  {
    __typename: "ManualKYCAMLReview",
    photo_id_front_file:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    },
    photo_id_back_file:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    },
    submitted_at?: string | null,
    completed_at?: string | null,
  } | null,
};

export type RejectKYCAMLManualReviewMutationVariables = {
  investor_account_id: string,
};

export type RejectKYCAMLManualReviewMutation = {
  rejectKYCAMLManualReview?: boolean | null,
};

export type ReleaseKYCAMLManualReviewMutationVariables = {
  investor_account_id: string,
};

export type ReleaseKYCAMLManualReviewMutation = {
  releaseKYCAMLManualReview?: boolean | null,
};

export type UpdateSuitabilityV2MutationVariables = {
  investor_account_id: string,
  survey: SurveyV2Input,
};

export type UpdateSuitabilityV2Mutation = {
  updateSuitabilityV2?:  {
    __typename: "SurveyV2",
    completed_at?: string | null,
    broker_dealer_assoc?:  {
      __typename: "SurveyV2Boolean",
      updated_at?: string | null,
      value?: boolean | null,
    } | null,
    annual_income?:  {
      __typename: "SurveyV2Int",
      updated_at?: string | null,
      value?: number | null,
    } | null,
    net_worth?:  {
      __typename: "SurveyV2Int",
      updated_at?: string | null,
      value?: number | null,
    } | null,
    objective?:  {
      __typename: "SurveyV2Objective",
      updated_at?: string | null,
      value?: SurveyV2ObjectiveChoice | null,
    } | null,
    pct_liquid_securities?:  {
      __typename: "SurveyV2Int",
      updated_at?: string | null,
      value?: number | null,
    } | null,
    pct_illiquid_securities?:  {
      __typename: "SurveyV2Int",
      updated_at?: string | null,
      value?: number | null,
    } | null,
    time_horizon?:  {
      __typename: "SurveyV2Int",
      updated_at?: string | null,
      value?: number | null,
    } | null,
    risk_profile?:  {
      __typename: "SurveyV2Int",
      updated_at?: string | null,
      value?: number | null,
    } | null,
    experience?:  {
      __typename: "SurveyV2Experience",
      experience_stocks?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      experience_bonds?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      experience_re?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      experience_alts?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      migrated?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
    } | null,
    employment?:  {
      __typename: "SurveyV2EmploymentDetails",
      employment_status?: EmploymentStatus | null,
      occupation?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
      employer?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
      employer_address?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
      employer_address2?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
      employer_city?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
      employer_state?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
      employer_zip?:  {
        __typename: "SurveyV2String",
        updated_at?: string | null,
        value?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateBdAccountMutationVariables = {
  investor_account_id: string,
  ssn: string,
  dob: string,
};

export type CreateBdAccountMutation = {
  createBdAccount?: boolean | null,
};

export type StoreSignatureFileMutationVariables = {
  signature: FileInput,
};

export type StoreSignatureFileMutation = {
  storeSignatureFile?: boolean | null,
};

export type StoreHeadshotMutationVariables = {
  photo: FileInput,
};

export type StoreHeadshotMutation = {
  storeHeadshot?:  {
    __typename: "File",
    bucket?: string | null,
    key?: string | null,
    region?: string | null,
    download_url?: string | null,
    upload_url?: string | null,
  } | null,
};

export type SignAutoInvestDocMutationVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
};

export type SignAutoInvestDocMutation = {
  signAutoInvestDoc?: boolean | null,
};

export type UpdateProfileMutationVariables = {
  user_id: string,
  profile?: ProfileInput | null,
};

export type UpdateProfileMutation = {
  updateProfile?: boolean | null,
};

export type SetInitialBranchDataMutationVariables = {
  user_id: string,
  initial_branch_data: string,
};

export type SetInitialBranchDataMutation = {
  setInitialBranchData?: boolean | null,
};

export type TriggerAutoInvestsMutationVariables = {
  trigger_date?: string | null,
};

export type TriggerAutoInvestsMutation = {
  triggerAutoInvests?: boolean | null,
};

export type IssueDividendsMutationVariables = {
  offering_id: string,
  period_start: string,
  period_end: string,
  record_date: string,
  daily_dividend_rate?: string | null,
  aggregate_dividend_amount?: string | null,
  is_special?: boolean | null,
};

export type IssueDividendsMutation = {
  issueDividends?: boolean | null,
};

export type StartDividendPaymentMutationVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
  period: string,
};

export type StartDividendPaymentMutation = {
  startDividendPayment?: boolean | null,
};

export type ProcessClosingMutationVariables = {
  offering_id: string,
  closing_at: string,
  new_nav: string,
};

export type ProcessClosingMutation = {
  processClosing?: boolean | null,
};

export type CompleteClosingMutationVariables = {
  offering_id: string,
  closing_at: string,
};

export type CompleteClosingMutation = {
  completeClosing?: boolean | null,
};

export type AssessOfferingAMFMutationVariables = {
  offering_id: string,
  closing_at: string,
};

export type AssessOfferingAMFMutation = {
  assessOfferingAMF?: boolean | null,
};

export type CompleteAMFAssessmentMutationVariables = {
  offering_id: string,
  closing_at: string,
};

export type CompleteAMFAssessmentMutation = {
  completeAMFAssessment?: boolean | null,
};

export type QueueSubscriptionAMFsMutationVariables = {
  offering_id: string,
  closing_shares: string,
  closing_nav: string,
  closing_at: string,
  period?: DateIntervalInput | null,
};

export type QueueSubscriptionAMFsMutation = {
  queueSubscriptionAMFs?: boolean | null,
};

export type BdExportClosingMutationVariables = {
  subscription_offer_id: string,
  closing_at: string,
};

export type BdExportClosingMutation = {
  bdExportClosing?:  {
    __typename: "BDExportClosing",
    subscription_offer_id: string,
    closing_at: string,
    file?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
  } | null,
};

export type ApproveSuitabilityMutationVariables = {
  trade_id: string,
};

export type ApproveSuitabilityMutation = {
  approveSuitability?: boolean | null,
};

export type SnoozeSuitabilityApprovalMutationVariables = {
  trade_id: string,
};

export type SnoozeSuitabilityApprovalMutation = {
  snoozeSuitabilityApproval?: boolean | null,
};

export type AddGiftRewardMutationVariables = {
  investor_account_id: string,
  amount: number,
  note: string,
};

export type AddGiftRewardMutation = {
  addGiftReward?: boolean | null,
};

export type CreateGoalMutationVariables = {
  investor_account_id: string,
  goal_type: GoalType,
  name: string,
  target_date: string,
  target_monthly_income?: number | null,
  target_value?: number | null,
  color?: string | null,
  icon?: string | null,
  allocate_shares?: boolean | null,
};

export type CreateGoalMutation = {
  createGoal:  {
    __typename: "Goal",
    investor_account_id?: string | null,
    goal_id: string,
    goal_type: GoalType,
    name: string,
    start_date: string,
    target_date: string,
    target_value?: number | null,
    target_monthly_income?: number | null,
    color?: string | null,
    icon?: string | null,
    current_value?: string | null,
    is_advised: boolean,
    calculated_monthly_amount: number,
    is_on_track: boolean,
  },
};

export type ResendEmailVerificationMutationVariables = {
  investor_account_id: string,
};

export type ResendEmailVerificationMutation = {
  resendEmailVerification?: boolean | null,
};

export type UpdateGoalMutationVariables = {
  investor_account_id: string,
  goal_id: string,
  goal_type?: GoalType | null,
  name?: string | null,
  start_date?: string | null,
  target_date?: string | null,
  target_monthly_income?: number | null,
  target_value?: number | null,
  color?: string | null,
  icon?: string | null,
};

export type UpdateGoalMutation = {
  updateGoal:  {
    __typename: "Goal",
    investor_account_id?: string | null,
    goal_id: string,
    goal_type: GoalType,
    name: string,
    start_date: string,
    target_date: string,
    target_value?: number | null,
    target_monthly_income?: number | null,
    color?: string | null,
    icon?: string | null,
    current_value?: string | null,
    is_advised: boolean,
    calculated_monthly_amount: number,
    is_on_track: boolean,
  },
};

export type RequestGoalAdviceMutationVariables = {
  investor_account_id: string,
  goal_id: string,
};

export type RequestGoalAdviceMutation = {
  requestGoalAdvice:  {
    __typename: "Goal",
    investor_account_id?: string | null,
    goal_id: string,
    goal_type: GoalType,
    name: string,
    start_date: string,
    target_date: string,
    target_value?: number | null,
    target_monthly_income?: number | null,
    color?: string | null,
    icon?: string | null,
    current_value?: string | null,
    is_advised: boolean,
    calculated_monthly_amount: number,
    is_on_track: boolean,
  },
};

export type RemoveGoalMutationVariables = {
  investor_account_id: string,
  goal_id: string,
};

export type RemoveGoalMutation = {
  removeGoal?: boolean | null,
};

export type WaitlistAddMutationVariables = {
  email: string,
  referrer_code?: string | null,
};

export type WaitlistAddMutation = {
  waitlistAdd:  {
    __typename: "WaitListContactInfo",
    email?: string | null,
    user_id?: string | null,
    investor_account_id?: string | null,
    referral_code?: string | null,
    has_access?: boolean | null,
    position?: number | null,
  },
};

export type WaitlistLogSocialMutationVariables = {
  code?: string | null,
  email?: string | null,
  platform: SocialPlatform,
  activity: SocialActivity,
  activity_at?: string | null,
  note?: string | null,
};

export type WaitlistLogSocialMutation = {
  waitlistLogSocial?: boolean | null,
};

export type WaitlistGrantAccessMutationVariables = {
  code?: string | null,
  email?: string | null,
};

export type WaitlistGrantAccessMutation = {
  waitlistGrantAccess?: boolean | null,
};

export type WaitlistGrantAccessBatchMutationVariables = {
  file: FileKeyBucketInput,
};

export type WaitlistGrantAccessBatchMutation = {
  waitlistGrantAccessBatch?: boolean | null,
};

export type WaitlistExportContactsMutationVariables = {
  access_filter?: WaitListAccessFilter | null,
  limit?: number | null,
};

export type WaitlistExportContactsMutation = {
  waitlistExportContacts:  {
    __typename: "WaitListContactExportResult",
    count: number,
    url?: string | null,
  },
};

export type UpdateSubscriptionOfferMutationVariables = {
  id: string,
  new_data: SubscriptionOfferInput,
  old_data: SubscriptionOfferInput,
};

export type UpdateSubscriptionOfferMutation = {
  updateSubscriptionOffer?: boolean | null,
};

export type UpsertPartnerMutationVariables = {
  partner_id: string,
  name: string,
  style: PartnerStyleInput,
};

export type UpsertPartnerMutation = {
  upsertPartner:  {
    __typename: "Partner",
    partner_id: string,
    name: string,
    style:  {
      __typename: "PartnerStyle",
      primary_logo?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      secondary_logo?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      bg_color?: string | null,
      html?: string | null,
    },
  },
};

export type DwollaUploadCustomerDocumentMutationVariables = {
  investor_account_id: string,
  document: DwollaCustomerDocInput,
};

export type DwollaUploadCustomerDocumentMutation = {
  dwollaUploadCustomerDocument?: boolean | null,
};

export type ForceVerifyEmailMutationVariables = {
  investor_account_id: string,
};

export type ForceVerifyEmailMutation = {
  forceVerifyEmail?: boolean | null,
};

export type IsEmailAvailableQueryVariables = {
  email: string,
};

export type IsEmailAvailableQuery = {
  isEmailAvailable?: boolean | null,
};

export type GetLeadQueryVariables = {
  id: string,
};

export type GetLeadQuery = {
  getLead?:  {
    __typename: "Lead",
    id: string,
    stored_at?: string | null,
    lead_source?: string | null,
    first_name?: string | null,
    last_name?: string | null,
    email?: string | null,
    phone?: string | null,
  } | null,
};

export type GetCurrentReferralCampaignQueryVariables = {
};

export type GetCurrentReferralCampaignQuery = {
  getCurrentReferralCampaign:  {
    __typename: "ReferralCampaign",
    start_date?: string | null,
    end_date?: string | null,
    referrer_amount?: string | null,
    referee_amount?: string | null,
    name?: string | null,
  },
};

export type GetReferralCampaignQueryVariables = {
  date: string,
};

export type GetReferralCampaignQuery = {
  getReferralCampaign?:  {
    __typename: "ReferralCampaign",
    start_date?: string | null,
    end_date?: string | null,
    referrer_amount?: string | null,
    referee_amount?: string | null,
    name?: string | null,
  } | null,
};

export type ListReferralCampaignsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type ListReferralCampaignsQuery = {
  listReferralCampaigns:  {
    __typename: "PaginatedReferralCampaigns",
    items:  Array< {
      __typename: "ReferralCampaign",
      start_date?: string | null,
      end_date?: string | null,
      referrer_amount?: string | null,
      referee_amount?: string | null,
      name?: string | null,
    } >,
    next_token?: string | null,
  },
};

export type GetInvestorAccountQueryVariables = {
  id: string,
};

export type GetInvestorAccountQuery = {
  getInvestorAccount?:  {
    __typename: "InvestorAccount",
    id: string,
    name?: string | null,
    email?: string | null,
    email_verified_at?: string | null,
    email2?: string | null,
    phone?: string | null,
    phone2?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    country?: string | null,
    status?: InvestorAccountStatus | null,
    individual_details?:  {
      __typename: "IndividualDetails",
      account_type: string,
      first_name: string,
      last_name: string,
      dob?: string | null,
      middle_name?: string | null,
      owners_accredited?: boolean | null,
      total_assets?: number | null,
    } | null,
    employment?:  {
      __typename: "EmploymentDetails",
      employment_status: EmploymentStatus,
      occupation?: string | null,
      employer?: string | null,
      employer_address?: string | null,
      employer_address2?: string | null,
      employer_city?: string | null,
      employer_state?: string | null,
      employer_zip?: string | null,
    } | null,
    domicile?: Domicile | null,
    needs_manual_kyc_aml_review?: boolean | null,
    manual_kyc_aml_review?:  {
      __typename: "ManualKYCAMLReview",
      photo_id_front_file:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      },
      photo_id_back_file:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      },
      submitted_at?: string | null,
      completed_at?: string | null,
    } | null,
    accreditation?:  {
      __typename: "Accreditation",
      started_at: string,
      accredited_on?: string | null,
      method: SignatureMethod,
      status: AccreditationStatus,
      docusign_details?:  {
        __typename: "DocuSignDetails",
        signer_name?: string | null,
        signer_email?: string | null,
      } | null,
      hellosign_details?:  {
        __typename: "HelloSignDetails",
        signer_name?: string | null,
        signer_email?: string | null,
      } | null,
    } | null,
    accreditation_self?:  {
      __typename: "SelfAccreditation",
      status: AccreditationStatus,
      created_at: string,
      accredited_at?: string | null,
      reason_annual_income?: boolean | null,
      reason_net_worth?: boolean | null,
      reason_certification?: boolean | null,
      reason_employment?: boolean | null,
    } | null,
    accreditation_hellosign?:  {
      __typename: "HelloSignAccreditation",
      status: AccreditationStatus,
      created_at: string,
      accredited_at?: string | null,
      signature_details:  {
        __typename: "HelloSignDetails",
        signer_name?: string | null,
        signer_email?: string | null,
      },
    } | null,
    accreditation_manual?:  {
      __typename: "ManualAccreditation",
      status: AccreditationStatus,
      created_at: string,
      accredited_at?: string | null,
    } | null,
    accredited_survey?:  {
      __typename: "SurveyMeta",
      date_submitted?: string | null,
    } | null,
    non_accredited_survey?:  {
      __typename: "SurveyMeta",
      date_submitted?: string | null,
    } | null,
    non_accredited_survey_v2?:  {
      __typename: "SurveyV2",
      completed_at?: string | null,
      broker_dealer_assoc?:  {
        __typename: "SurveyV2Boolean",
        updated_at?: string | null,
        value?: boolean | null,
      } | null,
      annual_income?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      net_worth?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      objective?:  {
        __typename: "SurveyV2Objective",
        updated_at?: string | null,
        value?: SurveyV2ObjectiveChoice | null,
      } | null,
      pct_liquid_securities?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      pct_illiquid_securities?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      time_horizon?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      risk_profile?:  {
        __typename: "SurveyV2Int",
        updated_at?: string | null,
        value?: number | null,
      } | null,
      experience?:  {
        __typename: "SurveyV2Experience",
        experience_stocks?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        experience_bonds?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        experience_re?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        experience_alts?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        migrated?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
      } | null,
      employment?:  {
        __typename: "SurveyV2EmploymentDetails",
        employment_status?: EmploymentStatus | null,
        occupation?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
        employer?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
        employer_address?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
        employer_address2?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
        employer_city?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
        employer_state?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
        employer_zip?:  {
          __typename: "SurveyV2String",
          updated_at?: string | null,
          value?: string | null,
        } | null,
      } | null,
    } | null,
    claims_is_accredited?: boolean | null,
    has_bd_account?: boolean | null,
    aml_date?: string | null,
    aml_status?: string | null,
    kyc_status?: string | null,
    kyc_aml?:  {
      __typename: "KycAml",
      passed_aml?: boolean | null,
      passed_kyc?: boolean | null,
    } | null,
    created_at?: string | null,
    created_ip_address?: string | null,
    pending_trades?:  Array< {
      __typename: "Trade",
      id: string,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      principal?: string | null,
      created_at?: string | null,
      opened_at?: string | null,
      is_drip?: boolean | null,
      redemption?:  {
        __typename: "RedemptionDetails",
        requested_amount?: string | null,
        redeem_all?: boolean | null,
        requested_date?: string | null,
      } | null,
      scheduled_closing_at?: string | null,
      settled_at?: string | null,
      status?: TradeStatus | null,
      shares?: string | null,
      share_price?: string | null,
      type?: TradeType | null,
      auto_invest?:  {
        __typename: "TradeAutoInvestDetails",
        day?: string | null,
      } | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      principal_suitability_approval?:  {
        __typename: "PrincipalSuitabilityApproval",
        approved_by?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      goal_id?: string | null,
    } > | null,
    was_invited?: boolean | null,
    rr_suitability_approval?:  {
      __typename: "RrSuitabilityApproval",
      approved_by?: string | null,
      approved_at?: string | null,
      updated_at?: string | null,
      approval_status?: ApprovalStatus | null,
      snooze_until?: string | null,
    } | null,
    rr_suitability_notes?:  Array< {
      __typename: "RRSuitabilityNote",
      created_at?: string | null,
      author?: string | null,
      note?: string | null,
    } > | null,
    referral_program?:  {
      __typename: "ReferralProgram",
      enrolled_at?: string | null,
      referral_count?: number | null,
      rewards_earned?: string | null,
      branch_link?: string | null,
      referrer_name?: string | null,
      referee_amount?: string | null,
      referee_completed_at?: string | null,
    } | null,
    rewards_balance?: string | null,
    tally_dividends?: string | null,
    tally_rewards_earned?: string | null,
    tally_rewards_applied?: string | null,
    is_name_locked?: boolean | null,
    promos?:  Array< {
      __typename: "Promo",
      code: PromoCode,
      name: string,
      start_date: string,
      end_date: string,
    } > | null,
    pricing_plan?: PricingPlan | null,
    accepted_tc_at?: string | null,
    unaccepted_agreements?: Array< AgreementCode > | null,
    partner?:  {
      __typename: "Partner",
      partner_id: string,
      name: string,
      style:  {
        __typename: "PartnerStyle",
        primary_logo?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        secondary_logo?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        bg_color?: string | null,
        html?: string | null,
      },
    } | null,
    hints?:  Array< {
      __typename: "InvestorHint",
      code: InvestorHintCode,
      status: HintStatus,
      severity: HintSeverity,
      text: string,
    } > | null,
  } | null,
};

export type GetConsolidatedInvestorQueryVariables = {
  id: string,
};

export type GetConsolidatedInvestorQuery = {
  getConsolidatedInvestor?:  {
    __typename: "ConsolidatedInvestor",
    account_value?:  {
      __typename: "AccountValue",
      pending_value: string,
      settled_value: string,
      total_value: string,
    } | null,
    acc_value?:  {
      __typename: "PositionValue",
      pending_value: string,
      settled_value: string,
      total_value: string,
    } | null,
    balance_history?:  Array< {
      __typename: "BalanceChange",
      changed_on: string,
      balance: string,
    } > | null,
    bank_accounts?:  Array< {
      __typename: "BankDetail",
      id?: string | null,
      name?: string | null,
      account_type?: string | null,
      account_number?: string | null,
      created_at?: string | null,
      default?: boolean | null,
      status?: BankDetailStatus | null,
      ins_name?: string | null,
      plaid_ins_id?: string | null,
      plaid_reauth_required?: boolean | null,
    } > | null,
    dividends:  {
      __typename: "DividendsV3",
      recent_dividends:  Array< {
        __typename: "Dividend",
        amount: string,
        issued_at: string,
        period: string,
        rewards_applied?: string | null,
      } >,
      months:  Array< {
        __typename: "Dividend",
        amount: string,
        issued_at: string,
        period: string,
        rewards_applied?: string | null,
      } >,
    },
    investor?:  {
      __typename: "InvestorAccount",
      id: string,
      name?: string | null,
      email?: string | null,
      email_verified_at?: string | null,
      email2?: string | null,
      phone?: string | null,
      phone2?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      country?: string | null,
      status?: InvestorAccountStatus | null,
      individual_details?:  {
        __typename: "IndividualDetails",
        account_type: string,
        first_name: string,
        last_name: string,
        dob?: string | null,
        middle_name?: string | null,
        owners_accredited?: boolean | null,
        total_assets?: number | null,
      } | null,
      employment?:  {
        __typename: "EmploymentDetails",
        employment_status: EmploymentStatus,
        occupation?: string | null,
        employer?: string | null,
        employer_address?: string | null,
        employer_address2?: string | null,
        employer_city?: string | null,
        employer_state?: string | null,
        employer_zip?: string | null,
      } | null,
      domicile?: Domicile | null,
      needs_manual_kyc_aml_review?: boolean | null,
      manual_kyc_aml_review?:  {
        __typename: "ManualKYCAMLReview",
        photo_id_front_file:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        },
        photo_id_back_file:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        },
        submitted_at?: string | null,
        completed_at?: string | null,
      } | null,
      accreditation?:  {
        __typename: "Accreditation",
        started_at: string,
        accredited_on?: string | null,
        method: SignatureMethod,
        status: AccreditationStatus,
        docusign_details?:  {
          __typename: "DocuSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        } | null,
        hellosign_details?:  {
          __typename: "HelloSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        } | null,
      } | null,
      accreditation_self?:  {
        __typename: "SelfAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
        reason_annual_income?: boolean | null,
        reason_net_worth?: boolean | null,
        reason_certification?: boolean | null,
        reason_employment?: boolean | null,
      } | null,
      accreditation_hellosign?:  {
        __typename: "HelloSignAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
        signature_details:  {
          __typename: "HelloSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        },
      } | null,
      accreditation_manual?:  {
        __typename: "ManualAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
      } | null,
      accredited_survey?:  {
        __typename: "SurveyMeta",
        date_submitted?: string | null,
      } | null,
      non_accredited_survey?:  {
        __typename: "SurveyMeta",
        date_submitted?: string | null,
      } | null,
      non_accredited_survey_v2?:  {
        __typename: "SurveyV2",
        completed_at?: string | null,
        broker_dealer_assoc?:  {
          __typename: "SurveyV2Boolean",
          updated_at?: string | null,
          value?: boolean | null,
        } | null,
        annual_income?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        net_worth?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        objective?:  {
          __typename: "SurveyV2Objective",
          updated_at?: string | null,
          value?: SurveyV2ObjectiveChoice | null,
        } | null,
        pct_liquid_securities?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        pct_illiquid_securities?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        time_horizon?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        risk_profile?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        experience?:  {
          __typename: "SurveyV2Experience",
          experience_stocks?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_bonds?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_re?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_alts?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          migrated?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
        } | null,
        employment?:  {
          __typename: "SurveyV2EmploymentDetails",
          employment_status?: EmploymentStatus | null,
          occupation?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_address?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_address2?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_city?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_state?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_zip?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
        } | null,
      } | null,
      claims_is_accredited?: boolean | null,
      has_bd_account?: boolean | null,
      aml_date?: string | null,
      aml_status?: string | null,
      kyc_status?: string | null,
      kyc_aml?:  {
        __typename: "KycAml",
        passed_aml?: boolean | null,
        passed_kyc?: boolean | null,
      } | null,
      created_at?: string | null,
      created_ip_address?: string | null,
      pending_trades?:  Array< {
        __typename: "Trade",
        id: string,
        subscription_offer?:  {
          __typename: "SubscriptionOffer",
          id: string,
          listed_at?: string | null,
          slug?: string | null,
          name?: string | null,
          display_name?: string | null,
          entity_name?: string | null,
          description?: string | null,
          offering_id?: string | null,
          status?: SubscriptionStatus | null,
          auto_invest_doc_v2_id?: string | null,
          auto_invest_doc_v2?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          documents?:  Array< {
            __typename: "SubscriptionOfferDocument",
            title: string,
            url: string,
            show_on_listing?: boolean | null,
            show_on_checkout?: boolean | null,
          } > | null,
          current_apy?: string | null,
          expected_return?: number | null,
          regulatory_rule_type?: RegulatoryRuleType | null,
          offer_type?: OfferType | null,
          asset_class?: AssetClass | null,
          investor_count?:  {
            __typename: "SettledPendingTotal",
            settled?: number | null,
            pending?: number | null,
            total?: number | null,
          } | null,
          subscription_doc?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          raised_amount?:  {
            __typename: "SettledPendingTotal",
            settled?: number | null,
            pending?: number | null,
            total?: number | null,
          } | null,
          funding_limit?: number | null,
          target_amount?: number | null,
          require_whole_shares?: boolean | null,
          min_invest_amount?: number | null,
          max_invest_amount?: number | null,
          share_price?: string | null,
          suggested_invest_amounts?: Array< number > | null,
          leverage_pct?: string | null,
          non_accredited_slots_full?: boolean | null,
          sfr?:  {
            __typename: "SFRSubscriptionOfferDetails",
            documents:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            offering_breakdown:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            volatility: string,
            info:  {
              __typename: "SFRPropertyInfo",
              address?: string | null,
              city?: string | null,
              state?: string | null,
              zip?: string | null,
              baths?: string | null,
              beds?: string | null,
              description?: string | null,
              electricity?: string | null,
              gas_type?: SFRGasType | null,
              headline: string,
              images?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              lat_long?:  {
                __typename: "LatLong",
                lat: string,
                long: string,
              } | null,
              lot_size?: number | null,
              name: string,
              nearby_employers?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              nearby_schools?:  Array< {
                __typename: "SFRNearbySchool",
                description: string,
                name: string,
                number_of_reviews: number,
                link: string,
                review_rating: string,
                students: number,
              } > | null,
              nearby_stores?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              septic?: boolean | null,
              sewer?: boolean | null,
              sqft?: number | null,
              tags?: Array< SFRPropertyInfoTag > | null,
              water?: string | null,
              year?: number | null,
            },
            market_data:  {
              __typename: "SFRMarketData",
              projected_dividend_yield: string,
              dividend_yield_historical_average?: string | null,
              dividend_yield_national_average?: string | null,
              dividend_yield_link: string,
              projected_equity_rate: string,
              equity_historical_average?: string | null,
              equity_national_average?: string | null,
              equity_link: string,
              summary: string,
            },
            status:  {
              __typename: "SFRStatus",
              status: SFRPropertyStatus,
              road_map?:  Array< {
                __typename: "SFRRoadMapItem",
                step: SFRRoadMapStep,
                description?: string | null,
              } > | null,
              tenant_leasing:  {
                __typename: "SFRDataSheet",
                link?: string | null,
                data?:  Array< {
                  __typename: "SFRDataSheetData",
                  description?: string | null,
                  highlight?: boolean | null,
                  title: string,
                  link?: string | null,
                  image?:  {
                    __typename: "Image",
                    url: string,
                    title?: string | null,
                    description?: string | null,
                    link?: string | null,
                    file?:  {
                      __typename: "File",
                      bucket?: string | null,
                      key?: string | null,
                      region?: string | null,
                      download_url?: string | null,
                      upload_url?: string | null,
                    } | null,
                  } | null,
                } > | null,
              },
              updates?:  Array< {
                __typename: "SFRUpdate",
                date: string,
                title: string,
                description?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
          } | null,
          total_shares?: string | null,
          auto_invest_doc_id?: string | null,
          auto_invest_doc?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          hints?: Array< SubscriptionOfferHint > | null,
        } | null,
        principal?: string | null,
        created_at?: string | null,
        opened_at?: string | null,
        is_drip?: boolean | null,
        redemption?:  {
          __typename: "RedemptionDetails",
          requested_amount?: string | null,
          redeem_all?: boolean | null,
          requested_date?: string | null,
        } | null,
        scheduled_closing_at?: string | null,
        settled_at?: string | null,
        status?: TradeStatus | null,
        shares?: string | null,
        share_price?: string | null,
        type?: TradeType | null,
        auto_invest?:  {
          __typename: "TradeAutoInvestDetails",
          day?: string | null,
        } | null,
        rr_suitability_approval?:  {
          __typename: "RrSuitabilityApproval",
          approved_by?: string | null,
          approved_at?: string | null,
          updated_at?: string | null,
          approval_status?: ApprovalStatus | null,
          snooze_until?: string | null,
        } | null,
        principal_suitability_approval?:  {
          __typename: "PrincipalSuitabilityApproval",
          approved_by?: string | null,
          updated_at?: string | null,
          approval_status?: ApprovalStatus | null,
          snooze_until?: string | null,
        } | null,
        goal_id?: string | null,
      } > | null,
      was_invited?: boolean | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      rr_suitability_notes?:  Array< {
        __typename: "RRSuitabilityNote",
        created_at?: string | null,
        author?: string | null,
        note?: string | null,
      } > | null,
      referral_program?:  {
        __typename: "ReferralProgram",
        enrolled_at?: string | null,
        referral_count?: number | null,
        rewards_earned?: string | null,
        branch_link?: string | null,
        referrer_name?: string | null,
        referee_amount?: string | null,
        referee_completed_at?: string | null,
      } | null,
      rewards_balance?: string | null,
      tally_dividends?: string | null,
      tally_rewards_earned?: string | null,
      tally_rewards_applied?: string | null,
      is_name_locked?: boolean | null,
      promos?:  Array< {
        __typename: "Promo",
        code: PromoCode,
        name: string,
        start_date: string,
        end_date: string,
      } > | null,
      pricing_plan?: PricingPlan | null,
      accepted_tc_at?: string | null,
      unaccepted_agreements?: Array< AgreementCode > | null,
      partner?:  {
        __typename: "Partner",
        partner_id: string,
        name: string,
        style:  {
          __typename: "PartnerStyle",
          primary_logo?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          secondary_logo?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          bg_color?: string | null,
          html?: string | null,
        },
      } | null,
      hints?:  Array< {
        __typename: "InvestorHint",
        code: InvestorHintCode,
        status: HintStatus,
        severity: HintSeverity,
        text: string,
      } > | null,
    } | null,
    referral_campaign:  {
      __typename: "ReferralCampaign",
      start_date?: string | null,
      end_date?: string | null,
      referrer_amount?: string | null,
      referee_amount?: string | null,
      name?: string | null,
    },
    referrals?:  Array< {
      __typename: "Referral",
      name?: string | null,
      created_at?: string | null,
      completed_at?: string | null,
      amount?: string | null,
    } > | null,
    trades?:  Array< {
      __typename: "Trade",
      id: string,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      principal?: string | null,
      created_at?: string | null,
      opened_at?: string | null,
      is_drip?: boolean | null,
      redemption?:  {
        __typename: "RedemptionDetails",
        requested_amount?: string | null,
        redeem_all?: boolean | null,
        requested_date?: string | null,
      } | null,
      scheduled_closing_at?: string | null,
      settled_at?: string | null,
      status?: TradeStatus | null,
      shares?: string | null,
      share_price?: string | null,
      type?: TradeType | null,
      auto_invest?:  {
        __typename: "TradeAutoInvestDetails",
        day?: string | null,
      } | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      principal_suitability_approval?:  {
        __typename: "PrincipalSuitabilityApproval",
        approved_by?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      goal_id?: string | null,
    } > | null,
    transactions?:  Array< {
      __typename: "TransactionV2",
      id: string,
      subscription_offer_id?: string | null,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      posted_at?: string | null,
      amount?: string | null,
      waived_amount?: string | null,
      code?: TransactionCode | null,
      title?: string | null,
      description?: string | null,
      dividend_detail?:  {
        __typename: "TxnDividendDetails",
        rewards_applied?: string | null,
        base_yield?: string | null,
        total_yield?: string | null,
      } | null,
    } > | null,
    user_profile?:  {
      __typename: "MyProfile",
      user_id: string,
      first_name?: string | null,
      last_name?: string | null,
      username?: string | null,
      headshot_url?: string | null,
      headshot?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      friend?:  {
        __typename: "FriendDetail",
        status: FriendStatus,
        is_requester?: boolean | null,
        created_at?: string | null,
        accepted_at?: string | null,
      } | null,
      signature_file?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      branch_link?: string | null,
      has_initial_branch_data?: boolean | null,
      app_prefs?:  {
        __typename: "AppPrefs",
        viewed_intro?: boolean | null,
      } | null,
    } | null,
    auto_invests?:  Array< {
      __typename: "AutoInvestScheduleV2",
      investor_account_id: string,
      autoinvest_id: string,
      subscription_offer_id: string,
      created_at?: string | null,
      start_date: string,
      amount: number,
      frequency: string,
      interval: number,
      days_of_month?: Array< number > | null,
      days_of_week?: Array< number > | null,
      is_disabled?: boolean | null,
      goal_id?: string | null,
    } > | null,
    goals?:  Array< {
      __typename: "Goal",
      investor_account_id?: string | null,
      goal_id: string,
      goal_type: GoalType,
      name: string,
      start_date: string,
      target_date: string,
      target_value?: number | null,
      target_monthly_income?: number | null,
      color?: string | null,
      icon?: string | null,
      current_value?: string | null,
      is_advised: boolean,
      calculated_monthly_amount: number,
      is_on_track: boolean,
    } > | null,
    subscription_offer?:  {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } | null,
    subscription?:  {
      __typename: "Subscription",
      auto_invest_signature?:  {
        __typename: "AutoInvestSignature",
        method: SignatureMethod,
        signed_at?: string | null,
        internalsign_details?:  {
          __typename: "InternalSignDetails",
          id: string,
          user_id: string,
          investor_account_id?: string | null,
          signed_at?: string | null,
          user_full_name?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } | null,
      } | null,
      subscription_offer_id?: string | null,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      signature?:  {
        __typename: "SubscriptionSignature",
        method: SignatureMethod,
        sent_at?: string | null,
        signed_at?: string | null,
      } | null,
      total_shares?: string | null,
      cost_basis?: string | null,
      tally_primary_cost?: string | null,
      tally_dividends?: string | null,
      tally_drip_cost?: string | null,
      share_price?: string | null,
      value?:  {
        __typename: "PositionValue",
        pending_value: string,
        settled_value: string,
        total_value: string,
      } | null,
    } | null,
    subscriptions?:  Array< {
      __typename: "Subscription",
      auto_invest_signature?:  {
        __typename: "AutoInvestSignature",
        method: SignatureMethod,
        signed_at?: string | null,
        internalsign_details?:  {
          __typename: "InternalSignDetails",
          id: string,
          user_id: string,
          investor_account_id?: string | null,
          signed_at?: string | null,
          user_full_name?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } | null,
      } | null,
      subscription_offer_id?: string | null,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      signature?:  {
        __typename: "SubscriptionSignature",
        method: SignatureMethod,
        sent_at?: string | null,
        signed_at?: string | null,
      } | null,
      total_shares?: string | null,
      cost_basis?: string | null,
      tally_primary_cost?: string | null,
      tally_dividends?: string | null,
      tally_drip_cost?: string | null,
      share_price?: string | null,
      value?:  {
        __typename: "PositionValue",
        pending_value: string,
        settled_value: string,
        total_value: string,
      } | null,
    } > | null,
  } | null,
};

export type AllInvestorAccountApplicationsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type AllInvestorAccountApplicationsQuery = {
  allInvestorAccountApplications:  {
    __typename: "PaginatedInvestorAccountApplications",
    items:  Array< {
      __typename: "InvestorAccountApplication",
      id: string,
      user_id: string,
      status: string,
      claims_is_accredited?: boolean | null,
      email?: string | null,
      email2?: string | null,
      phone?: string | null,
      phone2?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      country?: string | null,
      domicile?: Domicile | null,
      individual_details?:  {
        __typename: "IndividualDetails",
        account_type: string,
        first_name: string,
        last_name: string,
        dob?: string | null,
        middle_name?: string | null,
        owners_accredited?: boolean | null,
        total_assets?: number | null,
      } | null,
      partner_id?: string | null,
    } >,
    next_token?: string | null,
  },
};

export type GetAccreditedSurveyQueryVariables = {
  investor_account_id: string,
};

export type GetAccreditedSurveyQuery = {
  getAccreditedSurvey?:  {
    __typename: "Survey",
    questions?:  Array< {
      __typename: "SurveyItem",
      question: string,
      description?: string | null,
      answer?:  {
        __typename: "SurveyAnswer",
        type: string,
        boolean?: boolean | null,
        choice?:  {
          __typename: "SurveyChoice",
          label?: string | null,
        } | null,
        choices?:  {
          __typename: "SurveyMultiChoice",
          labels?: Array< string > | null,
          other?: string | null,
        } | null,
        number?: number | null,
        text?: string | null,
      } | null,
    } > | null,
  } | null,
};

export type GetNonAccreditedSurveyQueryVariables = {
  investor_account_id: string,
};

export type GetNonAccreditedSurveyQuery = {
  getNonAccreditedSurvey?:  {
    __typename: "Survey",
    questions?:  Array< {
      __typename: "SurveyItem",
      question: string,
      description?: string | null,
      answer?:  {
        __typename: "SurveyAnswer",
        type: string,
        boolean?: boolean | null,
        choice?:  {
          __typename: "SurveyChoice",
          label?: string | null,
        } | null,
        choices?:  {
          __typename: "SurveyMultiChoice",
          labels?: Array< string > | null,
          other?: string | null,
        } | null,
        number?: number | null,
        text?: string | null,
      } | null,
    } > | null,
  } | null,
};

export type GetInvestorAccountApplicationQueryVariables = {
  id: string,
};

export type GetInvestorAccountApplicationQuery = {
  getInvestorAccountApplication?:  {
    __typename: "InvestorAccountApplication",
    id: string,
    user_id: string,
    status: string,
    claims_is_accredited?: boolean | null,
    email?: string | null,
    email2?: string | null,
    phone?: string | null,
    phone2?: string | null,
    address?: string | null,
    address2?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    country?: string | null,
    domicile?: Domicile | null,
    individual_details?:  {
      __typename: "IndividualDetails",
      account_type: string,
      first_name: string,
      last_name: string,
      dob?: string | null,
      middle_name?: string | null,
      owners_accredited?: boolean | null,
      total_assets?: number | null,
    } | null,
    partner_id?: string | null,
  } | null,
};

export type GetTotalPrincipalBalanceQueryVariables = {
  investor_account_id: string,
};

export type GetTotalPrincipalBalanceQuery = {
  getTotalPrincipalBalance: string,
};

export type AllOfferingsQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type AllOfferingsQuery = {
  allOfferings:  {
    __typename: "PaginatedOfferings",
    items:  Array< {
      __typename: "Offering",
      id: string,
      property_type: PropertyType,
      share_price?: string | null,
      target_hold_months?: number | null,
      title: string,
    } >,
    next_token?: string | null,
  },
};

export type GetOfferingQueryVariables = {
  id: string,
};

export type GetOfferingQuery = {
  getOffering?:  {
    __typename: "Offering",
    id: string,
    property_type: PropertyType,
    share_price?: string | null,
    target_hold_months?: number | null,
    title: string,
  } | null,
};

export type ListDividendRatesQueryVariables = {
  offering_id: string,
  count?: number | null,
  nextToken?: string | null,
};

export type ListDividendRatesQuery = {
  listDividendRates:  {
    __typename: "PaginatedDividendRates",
    items:  Array< {
      __typename: "DividendRate",
      start_date?: string | null,
      end_date?: string | null,
      rate?: string | null,
    } >,
    next_token?: string | null,
  },
};

export type GetReferralsQueryVariables = {
  investor_account_id: string,
};

export type GetReferralsQuery = {
  getReferrals:  {
    __typename: "PaginatedReferrals",
    items:  Array< {
      __typename: "Referral",
      name?: string | null,
      created_at?: string | null,
      completed_at?: string | null,
      amount?: string | null,
    } >,
    next_token?: string | null,
  },
};

export type AllRewardsQueryVariables = {
  investor_account_id: string,
  count?: number | null,
  next_token?: string | null,
};

export type AllRewardsQuery = {
  allRewards:  {
    __typename: "PaginatedRewards",
    items:  Array< {
      __typename: "Reward",
      id: string,
      posted_at?: string | null,
      amount?: string | null,
      description?: string | null,
      code?: RewardCode | null,
    } >,
    next_token?: string | null,
  },
};

export type AllSubscriptionOffersQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type AllSubscriptionOffersQuery = {
  allSubscriptionOffers:  {
    __typename: "PaginatedSubscriptionOffers",
    items:  Array< {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } >,
    next_token?: string | null,
  },
};

export type ListSubscriptionOffersQueryVariables = {
  investor_account_id?: string | null,
  asset_class?: AssetClass | null,
};

export type ListSubscriptionOffersQuery = {
  listSubscriptionOffers:  {
    __typename: "PaginatedSubscriptionOffers",
    items:  Array< {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } >,
    next_token?: string | null,
  },
};

export type AdminListSubscriptionOffersQueryVariables = {
  asset_class?: AssetClass | null,
};

export type AdminListSubscriptionOffersQuery = {
  adminListSubscriptionOffers:  {
    __typename: "PaginatedSubscriptionOffers",
    items:  Array< {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } >,
    next_token?: string | null,
  },
};

export type GetSubscriptionOfferQueryVariables = {
  id: string,
};

export type GetSubscriptionOfferQuery = {
  getSubscriptionOffer?:  {
    __typename: "SubscriptionOffer",
    id: string,
    listed_at?: string | null,
    slug?: string | null,
    name?: string | null,
    display_name?: string | null,
    entity_name?: string | null,
    description?: string | null,
    offering_id?: string | null,
    status?: SubscriptionStatus | null,
    auto_invest_doc_v2_id?: string | null,
    auto_invest_doc_v2?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    documents?:  Array< {
      __typename: "SubscriptionOfferDocument",
      title: string,
      url: string,
      show_on_listing?: boolean | null,
      show_on_checkout?: boolean | null,
    } > | null,
    current_apy?: string | null,
    expected_return?: number | null,
    regulatory_rule_type?: RegulatoryRuleType | null,
    offer_type?: OfferType | null,
    asset_class?: AssetClass | null,
    investor_count?:  {
      __typename: "SettledPendingTotal",
      settled?: number | null,
      pending?: number | null,
      total?: number | null,
    } | null,
    subscription_doc?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    raised_amount?:  {
      __typename: "SettledPendingTotal",
      settled?: number | null,
      pending?: number | null,
      total?: number | null,
    } | null,
    funding_limit?: number | null,
    target_amount?: number | null,
    require_whole_shares?: boolean | null,
    min_invest_amount?: number | null,
    max_invest_amount?: number | null,
    share_price?: string | null,
    suggested_invest_amounts?: Array< number > | null,
    leverage_pct?: string | null,
    non_accredited_slots_full?: boolean | null,
    sfr?:  {
      __typename: "SFRSubscriptionOfferDetails",
      documents:  {
        __typename: "SFRDataSheet",
        link?: string | null,
        data?:  Array< {
          __typename: "SFRDataSheetData",
          description?: string | null,
          highlight?: boolean | null,
          title: string,
          link?: string | null,
          image?:  {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } | null,
        } > | null,
      },
      offering_breakdown:  {
        __typename: "SFRDataSheet",
        link?: string | null,
        data?:  Array< {
          __typename: "SFRDataSheetData",
          description?: string | null,
          highlight?: boolean | null,
          title: string,
          link?: string | null,
          image?:  {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } | null,
        } > | null,
      },
      volatility: string,
      info:  {
        __typename: "SFRPropertyInfo",
        address?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        baths?: string | null,
        beds?: string | null,
        description?: string | null,
        electricity?: string | null,
        gas_type?: SFRGasType | null,
        headline: string,
        images?:  Array< {
          __typename: "Image",
          url: string,
          title?: string | null,
          description?: string | null,
          link?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } > | null,
        lat_long?:  {
          __typename: "LatLong",
          lat: string,
          long: string,
        } | null,
        lot_size?: number | null,
        name: string,
        nearby_employers?:  Array< {
          __typename: "Image",
          url: string,
          title?: string | null,
          description?: string | null,
          link?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } > | null,
        nearby_schools?:  Array< {
          __typename: "SFRNearbySchool",
          description: string,
          name: string,
          number_of_reviews: number,
          link: string,
          review_rating: string,
          students: number,
        } > | null,
        nearby_stores?:  Array< {
          __typename: "Image",
          url: string,
          title?: string | null,
          description?: string | null,
          link?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } > | null,
        septic?: boolean | null,
        sewer?: boolean | null,
        sqft?: number | null,
        tags?: Array< SFRPropertyInfoTag > | null,
        water?: string | null,
        year?: number | null,
      },
      market_data:  {
        __typename: "SFRMarketData",
        projected_dividend_yield: string,
        dividend_yield_historical_average?: string | null,
        dividend_yield_national_average?: string | null,
        dividend_yield_link: string,
        projected_equity_rate: string,
        equity_historical_average?: string | null,
        equity_national_average?: string | null,
        equity_link: string,
        summary: string,
      },
      status:  {
        __typename: "SFRStatus",
        status: SFRPropertyStatus,
        road_map?:  Array< {
          __typename: "SFRRoadMapItem",
          step: SFRRoadMapStep,
          description?: string | null,
        } > | null,
        tenant_leasing:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        updates?:  Array< {
          __typename: "SFRUpdate",
          date: string,
          title: string,
          description?: string | null,
          image?:  {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } | null,
        } > | null,
      },
    } | null,
    total_shares?: string | null,
    auto_invest_doc_id?: string | null,
    auto_invest_doc?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    hints?: Array< SubscriptionOfferHint > | null,
  } | null,
};

export type GetSubscriptionOfferV2QueryVariables = {
  id?: string | null,
  slug?: string | null,
  investor_account_id?: string | null,
};

export type GetSubscriptionOfferV2Query = {
  getSubscriptionOfferV2?:  {
    __typename: "SubscriptionOffer",
    id: string,
    listed_at?: string | null,
    slug?: string | null,
    name?: string | null,
    display_name?: string | null,
    entity_name?: string | null,
    description?: string | null,
    offering_id?: string | null,
    status?: SubscriptionStatus | null,
    auto_invest_doc_v2_id?: string | null,
    auto_invest_doc_v2?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    documents?:  Array< {
      __typename: "SubscriptionOfferDocument",
      title: string,
      url: string,
      show_on_listing?: boolean | null,
      show_on_checkout?: boolean | null,
    } > | null,
    current_apy?: string | null,
    expected_return?: number | null,
    regulatory_rule_type?: RegulatoryRuleType | null,
    offer_type?: OfferType | null,
    asset_class?: AssetClass | null,
    investor_count?:  {
      __typename: "SettledPendingTotal",
      settled?: number | null,
      pending?: number | null,
      total?: number | null,
    } | null,
    subscription_doc?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    raised_amount?:  {
      __typename: "SettledPendingTotal",
      settled?: number | null,
      pending?: number | null,
      total?: number | null,
    } | null,
    funding_limit?: number | null,
    target_amount?: number | null,
    require_whole_shares?: boolean | null,
    min_invest_amount?: number | null,
    max_invest_amount?: number | null,
    share_price?: string | null,
    suggested_invest_amounts?: Array< number > | null,
    leverage_pct?: string | null,
    non_accredited_slots_full?: boolean | null,
    sfr?:  {
      __typename: "SFRSubscriptionOfferDetails",
      documents:  {
        __typename: "SFRDataSheet",
        link?: string | null,
        data?:  Array< {
          __typename: "SFRDataSheetData",
          description?: string | null,
          highlight?: boolean | null,
          title: string,
          link?: string | null,
          image?:  {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } | null,
        } > | null,
      },
      offering_breakdown:  {
        __typename: "SFRDataSheet",
        link?: string | null,
        data?:  Array< {
          __typename: "SFRDataSheetData",
          description?: string | null,
          highlight?: boolean | null,
          title: string,
          link?: string | null,
          image?:  {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } | null,
        } > | null,
      },
      volatility: string,
      info:  {
        __typename: "SFRPropertyInfo",
        address?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        baths?: string | null,
        beds?: string | null,
        description?: string | null,
        electricity?: string | null,
        gas_type?: SFRGasType | null,
        headline: string,
        images?:  Array< {
          __typename: "Image",
          url: string,
          title?: string | null,
          description?: string | null,
          link?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } > | null,
        lat_long?:  {
          __typename: "LatLong",
          lat: string,
          long: string,
        } | null,
        lot_size?: number | null,
        name: string,
        nearby_employers?:  Array< {
          __typename: "Image",
          url: string,
          title?: string | null,
          description?: string | null,
          link?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } > | null,
        nearby_schools?:  Array< {
          __typename: "SFRNearbySchool",
          description: string,
          name: string,
          number_of_reviews: number,
          link: string,
          review_rating: string,
          students: number,
        } > | null,
        nearby_stores?:  Array< {
          __typename: "Image",
          url: string,
          title?: string | null,
          description?: string | null,
          link?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } > | null,
        septic?: boolean | null,
        sewer?: boolean | null,
        sqft?: number | null,
        tags?: Array< SFRPropertyInfoTag > | null,
        water?: string | null,
        year?: number | null,
      },
      market_data:  {
        __typename: "SFRMarketData",
        projected_dividend_yield: string,
        dividend_yield_historical_average?: string | null,
        dividend_yield_national_average?: string | null,
        dividend_yield_link: string,
        projected_equity_rate: string,
        equity_historical_average?: string | null,
        equity_national_average?: string | null,
        equity_link: string,
        summary: string,
      },
      status:  {
        __typename: "SFRStatus",
        status: SFRPropertyStatus,
        road_map?:  Array< {
          __typename: "SFRRoadMapItem",
          step: SFRRoadMapStep,
          description?: string | null,
        } > | null,
        tenant_leasing:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        updates?:  Array< {
          __typename: "SFRUpdate",
          date: string,
          title: string,
          description?: string | null,
          image?:  {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } | null,
        } > | null,
      },
    } | null,
    total_shares?: string | null,
    auto_invest_doc_id?: string | null,
    auto_invest_doc?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    hints?: Array< SubscriptionOfferHint > | null,
  } | null,
};

export type GetSubscriptionQueryVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
};

export type GetSubscriptionQuery = {
  getSubscription?:  {
    __typename: "Subscription",
    auto_invest_signature?:  {
      __typename: "AutoInvestSignature",
      method: SignatureMethod,
      signed_at?: string | null,
      internalsign_details?:  {
        __typename: "InternalSignDetails",
        id: string,
        user_id: string,
        investor_account_id?: string | null,
        signed_at?: string | null,
        user_full_name?: string | null,
        file?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
      } | null,
    } | null,
    subscription_offer_id?: string | null,
    subscription_offer?:  {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } | null,
    signature?:  {
      __typename: "SubscriptionSignature",
      method: SignatureMethod,
      sent_at?: string | null,
      signed_at?: string | null,
    } | null,
    total_shares?: string | null,
    cost_basis?: string | null,
    tally_primary_cost?: string | null,
    tally_dividends?: string | null,
    tally_drip_cost?: string | null,
    share_price?: string | null,
    value?:  {
      __typename: "PositionValue",
      pending_value: string,
      settled_value: string,
      total_value: string,
    } | null,
  } | null,
};

export type ListSubscriptionsQueryVariables = {
  investor_account_id: string,
};

export type ListSubscriptionsQuery = {
  listSubscriptions?:  Array< {
    __typename: "Subscription",
    auto_invest_signature?:  {
      __typename: "AutoInvestSignature",
      method: SignatureMethod,
      signed_at?: string | null,
      internalsign_details?:  {
        __typename: "InternalSignDetails",
        id: string,
        user_id: string,
        investor_account_id?: string | null,
        signed_at?: string | null,
        user_full_name?: string | null,
        file?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
      } | null,
    } | null,
    subscription_offer_id?: string | null,
    subscription_offer?:  {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } | null,
    signature?:  {
      __typename: "SubscriptionSignature",
      method: SignatureMethod,
      sent_at?: string | null,
      signed_at?: string | null,
    } | null,
    total_shares?: string | null,
    cost_basis?: string | null,
    tally_primary_cost?: string | null,
    tally_dividends?: string | null,
    tally_drip_cost?: string | null,
    share_price?: string | null,
    value?:  {
      __typename: "PositionValue",
      pending_value: string,
      settled_value: string,
      total_value: string,
    } | null,
  } > | null,
};

export type AllTradesQueryVariables = {
  investor_account_id: string,
  count?: number | null,
  nextToken?: string | null,
};

export type AllTradesQuery = {
  allTrades:  {
    __typename: "PaginatedTrades",
    items:  Array< {
      __typename: "Trade",
      id: string,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      principal?: string | null,
      created_at?: string | null,
      opened_at?: string | null,
      is_drip?: boolean | null,
      redemption?:  {
        __typename: "RedemptionDetails",
        requested_amount?: string | null,
        redeem_all?: boolean | null,
        requested_date?: string | null,
      } | null,
      scheduled_closing_at?: string | null,
      settled_at?: string | null,
      status?: TradeStatus | null,
      shares?: string | null,
      share_price?: string | null,
      type?: TradeType | null,
      auto_invest?:  {
        __typename: "TradeAutoInvestDetails",
        day?: string | null,
      } | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      principal_suitability_approval?:  {
        __typename: "PrincipalSuitabilityApproval",
        approved_by?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      goal_id?: string | null,
    } >,
    next_token?: string | null,
  },
};

export type GetAccountValueQueryVariables = {
  investor_account_id: string,
};

export type GetAccountValueQuery = {
  getAccountValue:  {
    __typename: "AccountValue",
    pending_value: string,
    settled_value: string,
    total_value: string,
  },
};

export type GetAccountValueV2QueryVariables = {
  investor_account_id: string,
};

export type GetAccountValueV2Query = {
  getAccountValueV2:  {
    __typename: "PositionValue",
    pending_value: string,
    settled_value: string,
    total_value: string,
  },
};

export type GetBalanceHistoryQueryVariables = {
  investor_account_id: string,
};

export type GetBalanceHistoryQuery = {
  getBalanceHistory?:  {
    __typename: "BalanceHistory",
    items?:  Array< {
      __typename: "BalanceChange",
      changed_on: string,
      balance: string,
    } > | null,
  } | null,
};

export type GetTradeQueryVariables = {
  id: string,
};

export type GetTradeQuery = {
  getTrade?:  {
    __typename: "Trade",
    id: string,
    subscription_offer?:  {
      __typename: "SubscriptionOffer",
      id: string,
      listed_at?: string | null,
      slug?: string | null,
      name?: string | null,
      display_name?: string | null,
      entity_name?: string | null,
      description?: string | null,
      offering_id?: string | null,
      status?: SubscriptionStatus | null,
      auto_invest_doc_v2_id?: string | null,
      auto_invest_doc_v2?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      documents?:  Array< {
        __typename: "SubscriptionOfferDocument",
        title: string,
        url: string,
        show_on_listing?: boolean | null,
        show_on_checkout?: boolean | null,
      } > | null,
      current_apy?: string | null,
      expected_return?: number | null,
      regulatory_rule_type?: RegulatoryRuleType | null,
      offer_type?: OfferType | null,
      asset_class?: AssetClass | null,
      investor_count?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      subscription_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      raised_amount?:  {
        __typename: "SettledPendingTotal",
        settled?: number | null,
        pending?: number | null,
        total?: number | null,
      } | null,
      funding_limit?: number | null,
      target_amount?: number | null,
      require_whole_shares?: boolean | null,
      min_invest_amount?: number | null,
      max_invest_amount?: number | null,
      share_price?: string | null,
      suggested_invest_amounts?: Array< number > | null,
      leverage_pct?: string | null,
      non_accredited_slots_full?: boolean | null,
      sfr?:  {
        __typename: "SFRSubscriptionOfferDetails",
        documents:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        offering_breakdown:  {
          __typename: "SFRDataSheet",
          link?: string | null,
          data?:  Array< {
            __typename: "SFRDataSheetData",
            description?: string | null,
            highlight?: boolean | null,
            title: string,
            link?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
        volatility: string,
        info:  {
          __typename: "SFRPropertyInfo",
          address?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          baths?: string | null,
          beds?: string | null,
          description?: string | null,
          electricity?: string | null,
          gas_type?: SFRGasType | null,
          headline: string,
          images?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          lat_long?:  {
            __typename: "LatLong",
            lat: string,
            long: string,
          } | null,
          lot_size?: number | null,
          name: string,
          nearby_employers?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          nearby_schools?:  Array< {
            __typename: "SFRNearbySchool",
            description: string,
            name: string,
            number_of_reviews: number,
            link: string,
            review_rating: string,
            students: number,
          } > | null,
          nearby_stores?:  Array< {
            __typename: "Image",
            url: string,
            title?: string | null,
            description?: string | null,
            link?: string | null,
            file?:  {
              __typename: "File",
              bucket?: string | null,
              key?: string | null,
              region?: string | null,
              download_url?: string | null,
              upload_url?: string | null,
            } | null,
          } > | null,
          septic?: boolean | null,
          sewer?: boolean | null,
          sqft?: number | null,
          tags?: Array< SFRPropertyInfoTag > | null,
          water?: string | null,
          year?: number | null,
        },
        market_data:  {
          __typename: "SFRMarketData",
          projected_dividend_yield: string,
          dividend_yield_historical_average?: string | null,
          dividend_yield_national_average?: string | null,
          dividend_yield_link: string,
          projected_equity_rate: string,
          equity_historical_average?: string | null,
          equity_national_average?: string | null,
          equity_link: string,
          summary: string,
        },
        status:  {
          __typename: "SFRStatus",
          status: SFRPropertyStatus,
          road_map?:  Array< {
            __typename: "SFRRoadMapItem",
            step: SFRRoadMapStep,
            description?: string | null,
          } > | null,
          tenant_leasing:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          updates?:  Array< {
            __typename: "SFRUpdate",
            date: string,
            title: string,
            description?: string | null,
            image?:  {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } | null,
          } > | null,
        },
      } | null,
      total_shares?: string | null,
      auto_invest_doc_id?: string | null,
      auto_invest_doc?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      hints?: Array< SubscriptionOfferHint > | null,
    } | null,
    principal?: string | null,
    created_at?: string | null,
    opened_at?: string | null,
    is_drip?: boolean | null,
    redemption?:  {
      __typename: "RedemptionDetails",
      requested_amount?: string | null,
      redeem_all?: boolean | null,
      requested_date?: string | null,
    } | null,
    scheduled_closing_at?: string | null,
    settled_at?: string | null,
    status?: TradeStatus | null,
    shares?: string | null,
    share_price?: string | null,
    type?: TradeType | null,
    auto_invest?:  {
      __typename: "TradeAutoInvestDetails",
      day?: string | null,
    } | null,
    rr_suitability_approval?:  {
      __typename: "RrSuitabilityApproval",
      approved_by?: string | null,
      approved_at?: string | null,
      updated_at?: string | null,
      approval_status?: ApprovalStatus | null,
      snooze_until?: string | null,
    } | null,
    principal_suitability_approval?:  {
      __typename: "PrincipalSuitabilityApproval",
      approved_by?: string | null,
      updated_at?: string | null,
      approval_status?: ApprovalStatus | null,
      snooze_until?: string | null,
    } | null,
    goal_id?: string | null,
  } | null,
};

export type AllTransactionsV2QueryVariables = {
  investor_account_id: string,
  count?: number | null,
  nextToken?: string | null,
};

export type AllTransactionsV2Query = {
  allTransactionsV2:  {
    __typename: "PaginatedTransactionsV2",
    items:  Array< {
      __typename: "TransactionV2",
      id: string,
      subscription_offer_id?: string | null,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      posted_at?: string | null,
      amount?: string | null,
      waived_amount?: string | null,
      code?: TransactionCode | null,
      title?: string | null,
      description?: string | null,
      dividend_detail?:  {
        __typename: "TxnDividendDetails",
        rewards_applied?: string | null,
        base_yield?: string | null,
        total_yield?: string | null,
      } | null,
    } >,
    next_token?: string | null,
  },
};

export type AllAutoInvestSchedulesV2QueryVariables = {
  investor_account_id: string,
  subscription_offer_id?: string | null,
  nextToken?: string | null,
};

export type AllAutoInvestSchedulesV2Query = {
  allAutoInvestSchedulesV2:  {
    __typename: "PaginatedAutoInvestSchedulesV2",
    items:  Array< {
      __typename: "AutoInvestScheduleV2",
      investor_account_id: string,
      autoinvest_id: string,
      subscription_offer_id: string,
      created_at?: string | null,
      start_date: string,
      amount: number,
      frequency: string,
      interval: number,
      days_of_month?: Array< number > | null,
      days_of_week?: Array< number > | null,
      is_disabled?: boolean | null,
      goal_id?: string | null,
    } >,
    next_token?: string | null,
  },
};

export type GetAutoInvestScheduleV2QueryVariables = {
  investor_account_id: string,
  autoinvest_id: string,
};

export type GetAutoInvestScheduleV2Query = {
  getAutoInvestScheduleV2?:  {
    __typename: "AutoInvestScheduleV2",
    investor_account_id: string,
    autoinvest_id: string,
    subscription_offer_id: string,
    created_at?: string | null,
    start_date: string,
    amount: number,
    frequency: string,
    interval: number,
    days_of_month?: Array< number > | null,
    days_of_week?: Array< number > | null,
    is_disabled?: boolean | null,
    goal_id?: string | null,
  } | null,
};

export type AllMyUserInvestorRolesQueryVariables = {
  count?: number | null,
  nextToken?: string | null,
};

export type AllMyUserInvestorRolesQuery = {
  allMyUserInvestorRoles:  {
    __typename: "PaginatedUserInvestorRoles",
    items:  Array< {
      __typename: "UserInvestorRole",
      investor_id: string,
      user_id: string,
      role: string,
    } >,
    next_token?: string | null,
  },
};

export type GetInvestorAccountUploadURLQueryVariables = {
  investor_account_id: string,
  filename?: string | null,
  content_type?: string | null,
};

export type GetInvestorAccountUploadURLQuery = {
  getInvestorAccountUploadURL:  {
    __typename: "File",
    bucket?: string | null,
    key?: string | null,
    region?: string | null,
    download_url?: string | null,
    upload_url?: string | null,
  },
};

export type GetBankAccountsQueryVariables = {
  investor_account_id: string,
};

export type GetBankAccountsQuery = {
  getBankAccounts?:  Array< {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null > | null,
};

export type GetDefaultBankAccountQueryVariables = {
  investor_account_id: string,
};

export type GetDefaultBankAccountQuery = {
  getDefaultBankAccount?:  {
    __typename: "BankDetail",
    id?: string | null,
    name?: string | null,
    account_type?: string | null,
    account_number?: string | null,
    created_at?: string | null,
    default?: boolean | null,
    status?: BankDetailStatus | null,
    ins_name?: string | null,
    plaid_ins_id?: string | null,
    plaid_reauth_required?: boolean | null,
  } | null,
};

export type AllDividendsV3QueryVariables = {
  investor_account_id: string,
};

export type AllDividendsV3Query = {
  allDividendsV3:  {
    __typename: "DividendsV3",
    recent_dividends:  Array< {
      __typename: "Dividend",
      amount: string,
      issued_at: string,
      period: string,
      rewards_applied?: string | null,
    } >,
    months:  Array< {
      __typename: "Dividend",
      amount: string,
      issued_at: string,
      period: string,
      rewards_applied?: string | null,
    } >,
  },
};

export type GetBranchLinkQueryVariables = {
};

export type GetBranchLinkQuery = {
  getBranchLink?: string | null,
};

export type GetMyProfileQueryVariables = {
  user_id: string,
};

export type GetMyProfileQuery = {
  getMyProfile?:  {
    __typename: "MyProfile",
    user_id: string,
    first_name?: string | null,
    last_name?: string | null,
    username?: string | null,
    headshot_url?: string | null,
    headshot?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    friend?:  {
      __typename: "FriendDetail",
      status: FriendStatus,
      is_requester?: boolean | null,
      created_at?: string | null,
      accepted_at?: string | null,
    } | null,
    signature_file?:  {
      __typename: "File",
      bucket?: string | null,
      key?: string | null,
      region?: string | null,
      download_url?: string | null,
      upload_url?: string | null,
    } | null,
    branch_link?: string | null,
    has_initial_branch_data?: boolean | null,
    app_prefs?:  {
      __typename: "AppPrefs",
      viewed_intro?: boolean | null,
    } | null,
  } | null,
};

export type GetProfileQueryVariables = {
  friend_id: string,
};

export type GetProfileQuery = {
  getProfile:  {
    __typename: "OtherProfile",
    id: string,
    first_name?: string | null,
    last_name?: string | null,
    username?: string | null,
    headshot_url?: string | null,
    headshot?:  {
      __typename: "ReadOnlyFile",
      download_url?: string | null,
    } | null,
    friend?:  {
      __typename: "FriendDetail",
      status: FriendStatus,
      is_requester?: boolean | null,
      created_at?: string | null,
      accepted_at?: string | null,
    } | null,
  },
};

export type TradesPendingApprovalQueryVariables = {
  filter?: TradesApprovalFilter | null,
};

export type TradesPendingApprovalQuery = {
  tradesPendingApproval?:  Array< {
    __typename: "TradePendingApproval",
    trade?:  {
      __typename: "Trade",
      id: string,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      principal?: string | null,
      created_at?: string | null,
      opened_at?: string | null,
      is_drip?: boolean | null,
      redemption?:  {
        __typename: "RedemptionDetails",
        requested_amount?: string | null,
        redeem_all?: boolean | null,
        requested_date?: string | null,
      } | null,
      scheduled_closing_at?: string | null,
      settled_at?: string | null,
      status?: TradeStatus | null,
      shares?: string | null,
      share_price?: string | null,
      type?: TradeType | null,
      auto_invest?:  {
        __typename: "TradeAutoInvestDetails",
        day?: string | null,
      } | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      principal_suitability_approval?:  {
        __typename: "PrincipalSuitabilityApproval",
        approved_by?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      goal_id?: string | null,
    } | null,
    investor_account?:  {
      __typename: "InvestorAccount",
      id: string,
      name?: string | null,
      email?: string | null,
      email_verified_at?: string | null,
      email2?: string | null,
      phone?: string | null,
      phone2?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      country?: string | null,
      status?: InvestorAccountStatus | null,
      individual_details?:  {
        __typename: "IndividualDetails",
        account_type: string,
        first_name: string,
        last_name: string,
        dob?: string | null,
        middle_name?: string | null,
        owners_accredited?: boolean | null,
        total_assets?: number | null,
      } | null,
      employment?:  {
        __typename: "EmploymentDetails",
        employment_status: EmploymentStatus,
        occupation?: string | null,
        employer?: string | null,
        employer_address?: string | null,
        employer_address2?: string | null,
        employer_city?: string | null,
        employer_state?: string | null,
        employer_zip?: string | null,
      } | null,
      domicile?: Domicile | null,
      needs_manual_kyc_aml_review?: boolean | null,
      manual_kyc_aml_review?:  {
        __typename: "ManualKYCAMLReview",
        photo_id_front_file:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        },
        photo_id_back_file:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        },
        submitted_at?: string | null,
        completed_at?: string | null,
      } | null,
      accreditation?:  {
        __typename: "Accreditation",
        started_at: string,
        accredited_on?: string | null,
        method: SignatureMethod,
        status: AccreditationStatus,
        docusign_details?:  {
          __typename: "DocuSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        } | null,
        hellosign_details?:  {
          __typename: "HelloSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        } | null,
      } | null,
      accreditation_self?:  {
        __typename: "SelfAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
        reason_annual_income?: boolean | null,
        reason_net_worth?: boolean | null,
        reason_certification?: boolean | null,
        reason_employment?: boolean | null,
      } | null,
      accreditation_hellosign?:  {
        __typename: "HelloSignAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
        signature_details:  {
          __typename: "HelloSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        },
      } | null,
      accreditation_manual?:  {
        __typename: "ManualAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
      } | null,
      accredited_survey?:  {
        __typename: "SurveyMeta",
        date_submitted?: string | null,
      } | null,
      non_accredited_survey?:  {
        __typename: "SurveyMeta",
        date_submitted?: string | null,
      } | null,
      non_accredited_survey_v2?:  {
        __typename: "SurveyV2",
        completed_at?: string | null,
        broker_dealer_assoc?:  {
          __typename: "SurveyV2Boolean",
          updated_at?: string | null,
          value?: boolean | null,
        } | null,
        annual_income?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        net_worth?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        objective?:  {
          __typename: "SurveyV2Objective",
          updated_at?: string | null,
          value?: SurveyV2ObjectiveChoice | null,
        } | null,
        pct_liquid_securities?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        pct_illiquid_securities?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        time_horizon?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        risk_profile?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        experience?:  {
          __typename: "SurveyV2Experience",
          experience_stocks?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_bonds?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_re?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_alts?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          migrated?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
        } | null,
        employment?:  {
          __typename: "SurveyV2EmploymentDetails",
          employment_status?: EmploymentStatus | null,
          occupation?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_address?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_address2?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_city?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_state?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_zip?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
        } | null,
      } | null,
      claims_is_accredited?: boolean | null,
      has_bd_account?: boolean | null,
      aml_date?: string | null,
      aml_status?: string | null,
      kyc_status?: string | null,
      kyc_aml?:  {
        __typename: "KycAml",
        passed_aml?: boolean | null,
        passed_kyc?: boolean | null,
      } | null,
      created_at?: string | null,
      created_ip_address?: string | null,
      pending_trades?:  Array< {
        __typename: "Trade",
        id: string,
        subscription_offer?:  {
          __typename: "SubscriptionOffer",
          id: string,
          listed_at?: string | null,
          slug?: string | null,
          name?: string | null,
          display_name?: string | null,
          entity_name?: string | null,
          description?: string | null,
          offering_id?: string | null,
          status?: SubscriptionStatus | null,
          auto_invest_doc_v2_id?: string | null,
          auto_invest_doc_v2?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          documents?:  Array< {
            __typename: "SubscriptionOfferDocument",
            title: string,
            url: string,
            show_on_listing?: boolean | null,
            show_on_checkout?: boolean | null,
          } > | null,
          current_apy?: string | null,
          expected_return?: number | null,
          regulatory_rule_type?: RegulatoryRuleType | null,
          offer_type?: OfferType | null,
          asset_class?: AssetClass | null,
          investor_count?:  {
            __typename: "SettledPendingTotal",
            settled?: number | null,
            pending?: number | null,
            total?: number | null,
          } | null,
          subscription_doc?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          raised_amount?:  {
            __typename: "SettledPendingTotal",
            settled?: number | null,
            pending?: number | null,
            total?: number | null,
          } | null,
          funding_limit?: number | null,
          target_amount?: number | null,
          require_whole_shares?: boolean | null,
          min_invest_amount?: number | null,
          max_invest_amount?: number | null,
          share_price?: string | null,
          suggested_invest_amounts?: Array< number > | null,
          leverage_pct?: string | null,
          non_accredited_slots_full?: boolean | null,
          sfr?:  {
            __typename: "SFRSubscriptionOfferDetails",
            documents:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            offering_breakdown:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            volatility: string,
            info:  {
              __typename: "SFRPropertyInfo",
              address?: string | null,
              city?: string | null,
              state?: string | null,
              zip?: string | null,
              baths?: string | null,
              beds?: string | null,
              description?: string | null,
              electricity?: string | null,
              gas_type?: SFRGasType | null,
              headline: string,
              images?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              lat_long?:  {
                __typename: "LatLong",
                lat: string,
                long: string,
              } | null,
              lot_size?: number | null,
              name: string,
              nearby_employers?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              nearby_schools?:  Array< {
                __typename: "SFRNearbySchool",
                description: string,
                name: string,
                number_of_reviews: number,
                link: string,
                review_rating: string,
                students: number,
              } > | null,
              nearby_stores?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              septic?: boolean | null,
              sewer?: boolean | null,
              sqft?: number | null,
              tags?: Array< SFRPropertyInfoTag > | null,
              water?: string | null,
              year?: number | null,
            },
            market_data:  {
              __typename: "SFRMarketData",
              projected_dividend_yield: string,
              dividend_yield_historical_average?: string | null,
              dividend_yield_national_average?: string | null,
              dividend_yield_link: string,
              projected_equity_rate: string,
              equity_historical_average?: string | null,
              equity_national_average?: string | null,
              equity_link: string,
              summary: string,
            },
            status:  {
              __typename: "SFRStatus",
              status: SFRPropertyStatus,
              road_map?:  Array< {
                __typename: "SFRRoadMapItem",
                step: SFRRoadMapStep,
                description?: string | null,
              } > | null,
              tenant_leasing:  {
                __typename: "SFRDataSheet",
                link?: string | null,
                data?:  Array< {
                  __typename: "SFRDataSheetData",
                  description?: string | null,
                  highlight?: boolean | null,
                  title: string,
                  link?: string | null,
                  image?:  {
                    __typename: "Image",
                    url: string,
                    title?: string | null,
                    description?: string | null,
                    link?: string | null,
                    file?:  {
                      __typename: "File",
                      bucket?: string | null,
                      key?: string | null,
                      region?: string | null,
                      download_url?: string | null,
                      upload_url?: string | null,
                    } | null,
                  } | null,
                } > | null,
              },
              updates?:  Array< {
                __typename: "SFRUpdate",
                date: string,
                title: string,
                description?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
          } | null,
          total_shares?: string | null,
          auto_invest_doc_id?: string | null,
          auto_invest_doc?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          hints?: Array< SubscriptionOfferHint > | null,
        } | null,
        principal?: string | null,
        created_at?: string | null,
        opened_at?: string | null,
        is_drip?: boolean | null,
        redemption?:  {
          __typename: "RedemptionDetails",
          requested_amount?: string | null,
          redeem_all?: boolean | null,
          requested_date?: string | null,
        } | null,
        scheduled_closing_at?: string | null,
        settled_at?: string | null,
        status?: TradeStatus | null,
        shares?: string | null,
        share_price?: string | null,
        type?: TradeType | null,
        auto_invest?:  {
          __typename: "TradeAutoInvestDetails",
          day?: string | null,
        } | null,
        rr_suitability_approval?:  {
          __typename: "RrSuitabilityApproval",
          approved_by?: string | null,
          approved_at?: string | null,
          updated_at?: string | null,
          approval_status?: ApprovalStatus | null,
          snooze_until?: string | null,
        } | null,
        principal_suitability_approval?:  {
          __typename: "PrincipalSuitabilityApproval",
          approved_by?: string | null,
          updated_at?: string | null,
          approval_status?: ApprovalStatus | null,
          snooze_until?: string | null,
        } | null,
        goal_id?: string | null,
      } > | null,
      was_invited?: boolean | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      rr_suitability_notes?:  Array< {
        __typename: "RRSuitabilityNote",
        created_at?: string | null,
        author?: string | null,
        note?: string | null,
      } > | null,
      referral_program?:  {
        __typename: "ReferralProgram",
        enrolled_at?: string | null,
        referral_count?: number | null,
        rewards_earned?: string | null,
        branch_link?: string | null,
        referrer_name?: string | null,
        referee_amount?: string | null,
        referee_completed_at?: string | null,
      } | null,
      rewards_balance?: string | null,
      tally_dividends?: string | null,
      tally_rewards_earned?: string | null,
      tally_rewards_applied?: string | null,
      is_name_locked?: boolean | null,
      promos?:  Array< {
        __typename: "Promo",
        code: PromoCode,
        name: string,
        start_date: string,
        end_date: string,
      } > | null,
      pricing_plan?: PricingPlan | null,
      accepted_tc_at?: string | null,
      unaccepted_agreements?: Array< AgreementCode > | null,
      partner?:  {
        __typename: "Partner",
        partner_id: string,
        name: string,
        style:  {
          __typename: "PartnerStyle",
          primary_logo?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          secondary_logo?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          bg_color?: string | null,
          html?: string | null,
        },
      } | null,
      hints?:  Array< {
        __typename: "InvestorHint",
        code: InvestorHintCode,
        status: HintStatus,
        severity: HintSeverity,
        text: string,
      } > | null,
    } | null,
    extra_info?:  {
      __typename: "TradePendingApprovalExtraInfo",
      is_accredited: boolean,
      original_kyc_aml_info?: string | null,
      signed_doc_url?: string | null,
    } | null,
    subscription?:  {
      __typename: "Subscription",
      auto_invest_signature?:  {
        __typename: "AutoInvestSignature",
        method: SignatureMethod,
        signed_at?: string | null,
        internalsign_details?:  {
          __typename: "InternalSignDetails",
          id: string,
          user_id: string,
          investor_account_id?: string | null,
          signed_at?: string | null,
          user_full_name?: string | null,
          file?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
        } | null,
      } | null,
      subscription_offer_id?: string | null,
      subscription_offer?:  {
        __typename: "SubscriptionOffer",
        id: string,
        listed_at?: string | null,
        slug?: string | null,
        name?: string | null,
        display_name?: string | null,
        entity_name?: string | null,
        description?: string | null,
        offering_id?: string | null,
        status?: SubscriptionStatus | null,
        auto_invest_doc_v2_id?: string | null,
        auto_invest_doc_v2?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        documents?:  Array< {
          __typename: "SubscriptionOfferDocument",
          title: string,
          url: string,
          show_on_listing?: boolean | null,
          show_on_checkout?: boolean | null,
        } > | null,
        current_apy?: string | null,
        expected_return?: number | null,
        regulatory_rule_type?: RegulatoryRuleType | null,
        offer_type?: OfferType | null,
        asset_class?: AssetClass | null,
        investor_count?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        subscription_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        raised_amount?:  {
          __typename: "SettledPendingTotal",
          settled?: number | null,
          pending?: number | null,
          total?: number | null,
        } | null,
        funding_limit?: number | null,
        target_amount?: number | null,
        require_whole_shares?: boolean | null,
        min_invest_amount?: number | null,
        max_invest_amount?: number | null,
        share_price?: string | null,
        suggested_invest_amounts?: Array< number > | null,
        leverage_pct?: string | null,
        non_accredited_slots_full?: boolean | null,
        sfr?:  {
          __typename: "SFRSubscriptionOfferDetails",
          documents:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          offering_breakdown:  {
            __typename: "SFRDataSheet",
            link?: string | null,
            data?:  Array< {
              __typename: "SFRDataSheetData",
              description?: string | null,
              highlight?: boolean | null,
              title: string,
              link?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
          volatility: string,
          info:  {
            __typename: "SFRPropertyInfo",
            address?: string | null,
            city?: string | null,
            state?: string | null,
            zip?: string | null,
            baths?: string | null,
            beds?: string | null,
            description?: string | null,
            electricity?: string | null,
            gas_type?: SFRGasType | null,
            headline: string,
            images?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            lat_long?:  {
              __typename: "LatLong",
              lat: string,
              long: string,
            } | null,
            lot_size?: number | null,
            name: string,
            nearby_employers?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            nearby_schools?:  Array< {
              __typename: "SFRNearbySchool",
              description: string,
              name: string,
              number_of_reviews: number,
              link: string,
              review_rating: string,
              students: number,
            } > | null,
            nearby_stores?:  Array< {
              __typename: "Image",
              url: string,
              title?: string | null,
              description?: string | null,
              link?: string | null,
              file?:  {
                __typename: "File",
                bucket?: string | null,
                key?: string | null,
                region?: string | null,
                download_url?: string | null,
                upload_url?: string | null,
              } | null,
            } > | null,
            septic?: boolean | null,
            sewer?: boolean | null,
            sqft?: number | null,
            tags?: Array< SFRPropertyInfoTag > | null,
            water?: string | null,
            year?: number | null,
          },
          market_data:  {
            __typename: "SFRMarketData",
            projected_dividend_yield: string,
            dividend_yield_historical_average?: string | null,
            dividend_yield_national_average?: string | null,
            dividend_yield_link: string,
            projected_equity_rate: string,
            equity_historical_average?: string | null,
            equity_national_average?: string | null,
            equity_link: string,
            summary: string,
          },
          status:  {
            __typename: "SFRStatus",
            status: SFRPropertyStatus,
            road_map?:  Array< {
              __typename: "SFRRoadMapItem",
              step: SFRRoadMapStep,
              description?: string | null,
            } > | null,
            tenant_leasing:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            updates?:  Array< {
              __typename: "SFRUpdate",
              date: string,
              title: string,
              description?: string | null,
              image?:  {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } | null,
            } > | null,
          },
        } | null,
        total_shares?: string | null,
        auto_invest_doc_id?: string | null,
        auto_invest_doc?:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        } | null,
        hints?: Array< SubscriptionOfferHint > | null,
      } | null,
      signature?:  {
        __typename: "SubscriptionSignature",
        method: SignatureMethod,
        sent_at?: string | null,
        signed_at?: string | null,
      } | null,
      total_shares?: string | null,
      cost_basis?: string | null,
      tally_primary_cost?: string | null,
      tally_dividends?: string | null,
      tally_drip_cost?: string | null,
      share_price?: string | null,
      value?:  {
        __typename: "PositionValue",
        pending_value: string,
        settled_value: string,
        total_value: string,
      } | null,
    } | null,
  } > | null,
};

export type GetPendingManualKYCAMLReviewsQueryVariables = {
};

export type GetPendingManualKYCAMLReviewsQuery = {
  getPendingManualKYCAMLReviews?:  Array< {
    __typename: "PendingManualKYCAMLReview",
    investor_account?:  {
      __typename: "InvestorAccount",
      id: string,
      name?: string | null,
      email?: string | null,
      email_verified_at?: string | null,
      email2?: string | null,
      phone?: string | null,
      phone2?: string | null,
      address?: string | null,
      address2?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      country?: string | null,
      status?: InvestorAccountStatus | null,
      individual_details?:  {
        __typename: "IndividualDetails",
        account_type: string,
        first_name: string,
        last_name: string,
        dob?: string | null,
        middle_name?: string | null,
        owners_accredited?: boolean | null,
        total_assets?: number | null,
      } | null,
      employment?:  {
        __typename: "EmploymentDetails",
        employment_status: EmploymentStatus,
        occupation?: string | null,
        employer?: string | null,
        employer_address?: string | null,
        employer_address2?: string | null,
        employer_city?: string | null,
        employer_state?: string | null,
        employer_zip?: string | null,
      } | null,
      domicile?: Domicile | null,
      needs_manual_kyc_aml_review?: boolean | null,
      manual_kyc_aml_review?:  {
        __typename: "ManualKYCAMLReview",
        photo_id_front_file:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        },
        photo_id_back_file:  {
          __typename: "File",
          bucket?: string | null,
          key?: string | null,
          region?: string | null,
          download_url?: string | null,
          upload_url?: string | null,
        },
        submitted_at?: string | null,
        completed_at?: string | null,
      } | null,
      accreditation?:  {
        __typename: "Accreditation",
        started_at: string,
        accredited_on?: string | null,
        method: SignatureMethod,
        status: AccreditationStatus,
        docusign_details?:  {
          __typename: "DocuSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        } | null,
        hellosign_details?:  {
          __typename: "HelloSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        } | null,
      } | null,
      accreditation_self?:  {
        __typename: "SelfAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
        reason_annual_income?: boolean | null,
        reason_net_worth?: boolean | null,
        reason_certification?: boolean | null,
        reason_employment?: boolean | null,
      } | null,
      accreditation_hellosign?:  {
        __typename: "HelloSignAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
        signature_details:  {
          __typename: "HelloSignDetails",
          signer_name?: string | null,
          signer_email?: string | null,
        },
      } | null,
      accreditation_manual?:  {
        __typename: "ManualAccreditation",
        status: AccreditationStatus,
        created_at: string,
        accredited_at?: string | null,
      } | null,
      accredited_survey?:  {
        __typename: "SurveyMeta",
        date_submitted?: string | null,
      } | null,
      non_accredited_survey?:  {
        __typename: "SurveyMeta",
        date_submitted?: string | null,
      } | null,
      non_accredited_survey_v2?:  {
        __typename: "SurveyV2",
        completed_at?: string | null,
        broker_dealer_assoc?:  {
          __typename: "SurveyV2Boolean",
          updated_at?: string | null,
          value?: boolean | null,
        } | null,
        annual_income?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        net_worth?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        objective?:  {
          __typename: "SurveyV2Objective",
          updated_at?: string | null,
          value?: SurveyV2ObjectiveChoice | null,
        } | null,
        pct_liquid_securities?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        pct_illiquid_securities?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        time_horizon?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        risk_profile?:  {
          __typename: "SurveyV2Int",
          updated_at?: string | null,
          value?: number | null,
        } | null,
        experience?:  {
          __typename: "SurveyV2Experience",
          experience_stocks?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_bonds?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_re?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          experience_alts?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
          migrated?:  {
            __typename: "SurveyV2Int",
            updated_at?: string | null,
            value?: number | null,
          } | null,
        } | null,
        employment?:  {
          __typename: "SurveyV2EmploymentDetails",
          employment_status?: EmploymentStatus | null,
          occupation?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_address?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_address2?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_city?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_state?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
          employer_zip?:  {
            __typename: "SurveyV2String",
            updated_at?: string | null,
            value?: string | null,
          } | null,
        } | null,
      } | null,
      claims_is_accredited?: boolean | null,
      has_bd_account?: boolean | null,
      aml_date?: string | null,
      aml_status?: string | null,
      kyc_status?: string | null,
      kyc_aml?:  {
        __typename: "KycAml",
        passed_aml?: boolean | null,
        passed_kyc?: boolean | null,
      } | null,
      created_at?: string | null,
      created_ip_address?: string | null,
      pending_trades?:  Array< {
        __typename: "Trade",
        id: string,
        subscription_offer?:  {
          __typename: "SubscriptionOffer",
          id: string,
          listed_at?: string | null,
          slug?: string | null,
          name?: string | null,
          display_name?: string | null,
          entity_name?: string | null,
          description?: string | null,
          offering_id?: string | null,
          status?: SubscriptionStatus | null,
          auto_invest_doc_v2_id?: string | null,
          auto_invest_doc_v2?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          documents?:  Array< {
            __typename: "SubscriptionOfferDocument",
            title: string,
            url: string,
            show_on_listing?: boolean | null,
            show_on_checkout?: boolean | null,
          } > | null,
          current_apy?: string | null,
          expected_return?: number | null,
          regulatory_rule_type?: RegulatoryRuleType | null,
          offer_type?: OfferType | null,
          asset_class?: AssetClass | null,
          investor_count?:  {
            __typename: "SettledPendingTotal",
            settled?: number | null,
            pending?: number | null,
            total?: number | null,
          } | null,
          subscription_doc?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          raised_amount?:  {
            __typename: "SettledPendingTotal",
            settled?: number | null,
            pending?: number | null,
            total?: number | null,
          } | null,
          funding_limit?: number | null,
          target_amount?: number | null,
          require_whole_shares?: boolean | null,
          min_invest_amount?: number | null,
          max_invest_amount?: number | null,
          share_price?: string | null,
          suggested_invest_amounts?: Array< number > | null,
          leverage_pct?: string | null,
          non_accredited_slots_full?: boolean | null,
          sfr?:  {
            __typename: "SFRSubscriptionOfferDetails",
            documents:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            offering_breakdown:  {
              __typename: "SFRDataSheet",
              link?: string | null,
              data?:  Array< {
                __typename: "SFRDataSheetData",
                description?: string | null,
                highlight?: boolean | null,
                title: string,
                link?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
            volatility: string,
            info:  {
              __typename: "SFRPropertyInfo",
              address?: string | null,
              city?: string | null,
              state?: string | null,
              zip?: string | null,
              baths?: string | null,
              beds?: string | null,
              description?: string | null,
              electricity?: string | null,
              gas_type?: SFRGasType | null,
              headline: string,
              images?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              lat_long?:  {
                __typename: "LatLong",
                lat: string,
                long: string,
              } | null,
              lot_size?: number | null,
              name: string,
              nearby_employers?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              nearby_schools?:  Array< {
                __typename: "SFRNearbySchool",
                description: string,
                name: string,
                number_of_reviews: number,
                link: string,
                review_rating: string,
                students: number,
              } > | null,
              nearby_stores?:  Array< {
                __typename: "Image",
                url: string,
                title?: string | null,
                description?: string | null,
                link?: string | null,
                file?:  {
                  __typename: "File",
                  bucket?: string | null,
                  key?: string | null,
                  region?: string | null,
                  download_url?: string | null,
                  upload_url?: string | null,
                } | null,
              } > | null,
              septic?: boolean | null,
              sewer?: boolean | null,
              sqft?: number | null,
              tags?: Array< SFRPropertyInfoTag > | null,
              water?: string | null,
              year?: number | null,
            },
            market_data:  {
              __typename: "SFRMarketData",
              projected_dividend_yield: string,
              dividend_yield_historical_average?: string | null,
              dividend_yield_national_average?: string | null,
              dividend_yield_link: string,
              projected_equity_rate: string,
              equity_historical_average?: string | null,
              equity_national_average?: string | null,
              equity_link: string,
              summary: string,
            },
            status:  {
              __typename: "SFRStatus",
              status: SFRPropertyStatus,
              road_map?:  Array< {
                __typename: "SFRRoadMapItem",
                step: SFRRoadMapStep,
                description?: string | null,
              } > | null,
              tenant_leasing:  {
                __typename: "SFRDataSheet",
                link?: string | null,
                data?:  Array< {
                  __typename: "SFRDataSheetData",
                  description?: string | null,
                  highlight?: boolean | null,
                  title: string,
                  link?: string | null,
                  image?:  {
                    __typename: "Image",
                    url: string,
                    title?: string | null,
                    description?: string | null,
                    link?: string | null,
                    file?:  {
                      __typename: "File",
                      bucket?: string | null,
                      key?: string | null,
                      region?: string | null,
                      download_url?: string | null,
                      upload_url?: string | null,
                    } | null,
                  } | null,
                } > | null,
              },
              updates?:  Array< {
                __typename: "SFRUpdate",
                date: string,
                title: string,
                description?: string | null,
                image?:  {
                  __typename: "Image",
                  url: string,
                  title?: string | null,
                  description?: string | null,
                  link?: string | null,
                  file?:  {
                    __typename: "File",
                    bucket?: string | null,
                    key?: string | null,
                    region?: string | null,
                    download_url?: string | null,
                    upload_url?: string | null,
                  } | null,
                } | null,
              } > | null,
            },
          } | null,
          total_shares?: string | null,
          auto_invest_doc_id?: string | null,
          auto_invest_doc?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          hints?: Array< SubscriptionOfferHint > | null,
        } | null,
        principal?: string | null,
        created_at?: string | null,
        opened_at?: string | null,
        is_drip?: boolean | null,
        redemption?:  {
          __typename: "RedemptionDetails",
          requested_amount?: string | null,
          redeem_all?: boolean | null,
          requested_date?: string | null,
        } | null,
        scheduled_closing_at?: string | null,
        settled_at?: string | null,
        status?: TradeStatus | null,
        shares?: string | null,
        share_price?: string | null,
        type?: TradeType | null,
        auto_invest?:  {
          __typename: "TradeAutoInvestDetails",
          day?: string | null,
        } | null,
        rr_suitability_approval?:  {
          __typename: "RrSuitabilityApproval",
          approved_by?: string | null,
          approved_at?: string | null,
          updated_at?: string | null,
          approval_status?: ApprovalStatus | null,
          snooze_until?: string | null,
        } | null,
        principal_suitability_approval?:  {
          __typename: "PrincipalSuitabilityApproval",
          approved_by?: string | null,
          updated_at?: string | null,
          approval_status?: ApprovalStatus | null,
          snooze_until?: string | null,
        } | null,
        goal_id?: string | null,
      } > | null,
      was_invited?: boolean | null,
      rr_suitability_approval?:  {
        __typename: "RrSuitabilityApproval",
        approved_by?: string | null,
        approved_at?: string | null,
        updated_at?: string | null,
        approval_status?: ApprovalStatus | null,
        snooze_until?: string | null,
      } | null,
      rr_suitability_notes?:  Array< {
        __typename: "RRSuitabilityNote",
        created_at?: string | null,
        author?: string | null,
        note?: string | null,
      } > | null,
      referral_program?:  {
        __typename: "ReferralProgram",
        enrolled_at?: string | null,
        referral_count?: number | null,
        rewards_earned?: string | null,
        branch_link?: string | null,
        referrer_name?: string | null,
        referee_amount?: string | null,
        referee_completed_at?: string | null,
      } | null,
      rewards_balance?: string | null,
      tally_dividends?: string | null,
      tally_rewards_earned?: string | null,
      tally_rewards_applied?: string | null,
      is_name_locked?: boolean | null,
      promos?:  Array< {
        __typename: "Promo",
        code: PromoCode,
        name: string,
        start_date: string,
        end_date: string,
      } > | null,
      pricing_plan?: PricingPlan | null,
      accepted_tc_at?: string | null,
      unaccepted_agreements?: Array< AgreementCode > | null,
      partner?:  {
        __typename: "Partner",
        partner_id: string,
        name: string,
        style:  {
          __typename: "PartnerStyle",
          primary_logo?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          secondary_logo?:  {
            __typename: "File",
            bucket?: string | null,
            key?: string | null,
            region?: string | null,
            download_url?: string | null,
            upload_url?: string | null,
          } | null,
          bg_color?: string | null,
          html?: string | null,
        },
      } | null,
      hints?:  Array< {
        __typename: "InvestorHint",
        code: InvestorHintCode,
        status: HintStatus,
        severity: HintSeverity,
        text: string,
      } > | null,
    } | null,
    photo_id_front_uri?: string | null,
    photo_id_back_uri?: string | null,
  } > | null,
};

export type GetInvestorYearStatsQueryVariables = {
  investor_account_id: string,
};

export type GetInvestorYearStatsQuery = {
  getInvestorYearStats?:  {
    __typename: "YearInReview",
    account_join_date: string,
    yearly_details?:  Array< {
      __typename: "YearInReviewDetail",
      year: number,
      bonus_payout_percent?: string | null,
      bonus_payout_percentile?: string | null,
      ending_balance?: string | null,
      ending_balance_percentile?: string | null,
      investment_count?: number | null,
      investment_count_percentile?: string | null,
      investment_sum?: string | null,
      investment_sum_percentile?: string | null,
    } > | null,
  } | null,
};

export type GetInvestorTaxDocumentsQueryVariables = {
  investor_account_id: string,
};

export type GetInvestorTaxDocumentsQuery = {
  getInvestorTaxDocuments?:  Array< {
    __typename: "TaxDocumentGroup",
    tax_period: number,
    forms?:  Array< {
      __typename: "TaxDocumentDetail",
      form_code: string,
      suffix?: string | null,
      document_file:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      },
    } > | null,
  } > | null,
};

export type GetTaxDocumentPresignedURLQueryVariables = {
  investor_account_id: string,
  tax_period: number,
  form_code: string,
  suffix: string,
};

export type GetTaxDocumentPresignedURLQuery = {
  getTaxDocumentPresignedURL:  {
    __typename: "ReadOnlyFile",
    download_url?: string | null,
  },
};

export type GetRedemptionPreflightInfoQueryVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
};

export type GetRedemptionPreflightInfoQuery = {
  getRedemptionPreflightInfo:  {
    __typename: "RedemptionPreflightInfo",
    full_value: string,
    redeemable_value: string,
    time_restricted_value?: string | null,
    goal_restricted_value?: string | null,
    next_scheduled_date: string,
    pending_investments: string,
    pending_redemptions: string,
  },
};

export type GetInvestPreflightInfoQueryVariables = {
  investor_account_id: string,
  subscription_offer_id: string,
  amount: number,
};

export type GetInvestPreflightInfoQuery = {
  getInvestPreflightInfo:  {
    __typename: "InvestPreflightInfo",
    hints?: Array< InvestPreflightHint > | null,
  },
};

export type GetGoalQueryVariables = {
  investor_account_id: string,
  goal_id: string,
};

export type GetGoalQuery = {
  getGoal:  {
    __typename: "Goal",
    investor_account_id?: string | null,
    goal_id: string,
    goal_type: GoalType,
    name: string,
    start_date: string,
    target_date: string,
    target_value?: number | null,
    target_monthly_income?: number | null,
    color?: string | null,
    icon?: string | null,
    current_value?: string | null,
    is_advised: boolean,
    calculated_monthly_amount: number,
    is_on_track: boolean,
  },
};

export type ListGoalsQueryVariables = {
  investor_account_id: string,
};

export type ListGoalsQuery = {
  listGoals:  Array< {
    __typename: "Goal",
    investor_account_id?: string | null,
    goal_id: string,
    goal_type: GoalType,
    name: string,
    start_date: string,
    target_date: string,
    target_value?: number | null,
    target_monthly_income?: number | null,
    color?: string | null,
    icon?: string | null,
    current_value?: string | null,
    is_advised: boolean,
    calculated_monthly_amount: number,
    is_on_track: boolean,
  } >,
};

export type GetGoalHistoryQueryVariables = {
  investor_account_id: string,
  goal_id: string,
};

export type GetGoalHistoryQuery = {
  getGoalHistory:  Array< {
    __typename: "GoalHistoryItem",
    date: string,
    value: string,
  } >,
};

export type WaitlistLookupEmailQueryVariables = {
  email: string,
};

export type WaitlistLookupEmailQuery = {
  waitlistLookupEmail?:  {
    __typename: "WaitListShortContactInfo",
    email?: string | null,
    referral_code?: string | null,
    has_access?: boolean | null,
    position?: number | null,
  } | null,
};

export type WaitlistGetPositionQueryVariables = {
  code: string,
};

export type WaitlistGetPositionQuery = {
  waitlistGetPosition?:  {
    __typename: "WaitListShortContactInfo",
    email?: string | null,
    referral_code?: string | null,
    has_access?: boolean | null,
    position?: number | null,
  } | null,
};

export type WaitlistListContactsQueryVariables = {
  access_filter?: WaitListAccessFilter | null,
  limit: number,
};

export type WaitlistListContactsQuery = {
  waitlistListContacts:  {
    __typename: "PaginatedWaitListContacts",
    items:  Array< {
      __typename: "WaitListContactInfo",
      email?: string | null,
      user_id?: string | null,
      investor_account_id?: string | null,
      referral_code?: string | null,
      has_access?: boolean | null,
      position?: number | null,
    } >,
    next_token?: string | null,
  },
};

export type AllPartnersQueryVariables = {
};

export type AllPartnersQuery = {
  allPartners:  Array< {
    __typename: "Partner",
    partner_id: string,
    name: string,
    style:  {
      __typename: "PartnerStyle",
      primary_logo?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      secondary_logo?:  {
        __typename: "File",
        bucket?: string | null,
        key?: string | null,
        region?: string | null,
        download_url?: string | null,
        upload_url?: string | null,
      } | null,
      bg_color?: string | null,
      html?: string | null,
    },
  } >,
};

export type GetMonthlyStatementQueryVariables = {
  investor_account_id: string,
  month_ym: string,
};

export type GetMonthlyStatementQuery = {
  getMonthlyStatement:  {
    __typename: "MonthlyStatement",
    holdings:  {
      __typename: "MSHoldings",
      items?:  Array< {
        __typename: "MSHolding",
        subscription_offer_name: string,
        type: string,
        start_shares: string,
        end_shares: string,
        end_share_price: string,
        end_value: string,
      } > | null,
      totals:  {
        __typename: "MSHoldingTotals",
        start_value: string,
        end_value: string,
      },
    },
    activity:  {
      __typename: "MSActivity",
      trades:  {
        __typename: "MSTrades",
        items?:  Array< {
          __typename: "MSTrade",
          date: string,
          subscription_offer_name: string,
          description: string,
          share_price?: string | null,
          shares?: string | null,
          amount?: string | null,
        } > | null,
        totals:  {
          __typename: "MSTradeTotals",
          amount: string,
        },
      },
      earnings:  {
        __typename: "MSEarnings",
        items?:  Array< {
          __typename: "MSEarning",
          date: string,
          subscription_offer_name: string,
          type: string,
          rewards_applied?: string | null,
          net_amount: string,
        } > | null,
        totals:  {
          __typename: "MSEarningTotals",
          rewards_applied: string,
          net_amount: string,
        },
      },
      rewards:  {
        __typename: "MSRewards",
        items?:  Array< {
          __typename: "MSReward",
          date: string,
          description: string,
          amount?: string | null,
          end_balance: string,
        } > | null,
        totals:  {
          __typename: "MSRewardTotals",
          start_balance: string,
          end_balance: string,
        },
      },
      fees:  {
        __typename: "MSFees",
        items?:  Array< {
          __typename: "MSFee",
          date: string,
          description: string,
          fee_amount?: string | null,
        } > | null,
        totals:  {
          __typename: "MSFeeTotals",
          fee_amount: string,
        },
      },
    },
  },
};

export type BdListSubscriptionOffersQueryVariables = {
};

export type BdListSubscriptionOffersQuery = {
  bdListSubscriptionOffers:  Array< {
    __typename: "BDSubscriptionOffer",
    id: string,
    display_name?: string | null,
    entity_name?: string | null,
    offering_id?: string | null,
    status?: SubscriptionStatus | null,
    closings_to_export?: number | null,
    last_closing_date?: string | null,
    total_closings?: number | null,
    total_dollars?: string | null,
  } >,
};

export type BdListSubscriptionOfferClosingsQueryVariables = {
  subscription_offer_id: string,
};

export type BdListSubscriptionOfferClosingsQuery = {
  bdListSubscriptionOfferClosings:  Array< {
    __typename: "BDSubscriptionOfferClosing",
    subscription_offer_id: string,
    closing_at: string,
    display_name?: string | null,
    entity_name?: string | null,
    offering_id?: string | null,
    total_dollars?: string | null,
    drip_amount?: string | null,
    num_trades?: number | null,
    bd_exported_at?: string | null,
    skip_bd_export?: boolean | null,
  } >,
};
